import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ApplicationService } from './application.service';
import { ToastrService } from 'ngx-toastr';
import { _ } from 'underscore';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { EnvironmentService } from '../environment.service';
import { AmChartsService, AmChart } from "@amcharts/amcharts3-angular";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { map } from 'jquery';
import { isArray } from 'ngx-bootstrap/chronos';
import {Router } from '@angular/router';
import { PipeTransform, Pipe } from '@angular/core';
declare var alasql: any;
declare var $: any;

@Pipe({name: 'keys'})
export class KeysPipe implements PipeTransform {
  transform(value) : any {
    let keys = [];
    for (let key in value) {
      keys.push({key: key, value: value[key]});
    }
    return keys;
  }
}
@Component({
  selector: "app-application",
  templateUrl: "./application.component.html",
  styleUrls: ["./application.component.scss"],
})
export class ApplicationComponent implements OnInit {
  objectKeys = Object.keys;
  @ViewChild('fileInputEdit') fileInputEdit: ElementRef;
  pageLoader: boolean = true;
  selected = [{ id: 2, name: "(GMT-11:00) Etc/GMT+11" }];
  connector_id;
  timezoneSelect = [
    { id: 1, name: "(GMT-12:00) Etc/GMT+12" },
    { id: 2, name: "(GMT-11:00) Etc/GMT+11" },
    { id: 3, name: "(GMT-11:00) Pacific/Midway" },
    { id: 4, name: "(GMT-11:00) Pacific/Niue" },
    { id: 5, name: "(GMT-11:00) Pacific/Pago Pago" },
    { id: 6, name: "(GMT-10:00) Etc/GMT+10" },
    { id: 7, name: "(GMT-10:00) HST" },
    { id: 8, name: "(GMT-10:00) Pacific/Honolulu" },
    { id: 9, name: "(GMT-10:00) Pacific/Rarotonga" },
    { id: 10, name: "(GMT-10:00) Pacific/Tahiti" },
    { id: 11, name: "(GMT-09:30) Pacific/Marquesas" },
    { id: 12, name: "(GMT-09:00) America/Adak" },
    { id: 13, name: "(GMT-09:00) Etc/GMT+9" },
    { id: 14, name: "(GMT-09:00) Pacific/Gambier" },
    { id: 15, name: "(GMT-08:00) America/Anchorage" },
    { id: 16, name: "(GMT-08:00) America/Juneau" },
    { id: 17, name: "(GMT-08:00) America/Metlakatla" },
    { id: 18, name: "(GMT-08:00) America/Nome" },
    { id: 19, name: "(GMT-08:00) America/Sitka" },
    { id: 20, name: "(GMT-08:00) America/Yakutat" },
    { id: 21, name: "(GMT-08:00) Etc/GMT+8" },
    { id: 22, name: "(GMT-08:00) Pacific/Pitcairn" },
    { id: 23, name: "(GMT-07:00) America/Creston" },
    { id: 24, name: "(GMT-07:00) America/Dawson" },
    { id: 25, name: "(GMT-07:00) America/Dawson Creek" },
    { id: 26, name: "(GMT-07:00) America/Fort Nelson" },
    { id: 27, name: "(GMT-07:00) America/Hermosillo" },
    { id: 28, name: "(GMT-07:00) America/Los Angeles" },
    { id: 29, name: "(GMT-07:00) America/Phoenix" },
    { id: 30, name: "(GMT-07:00) America/Tijuana" },
    { id: 31, name: "(GMT-07:00) America/Vancouver" },
    { id: 32, name: "(GMT-07:00) America/Whitehorse" },
    { id: 33, name: "(GMT-07:00) Etc/GMT+7" },
    { id: 34, name: "(GMT-07:00) MST" },
    { id: 35, name: "(GMT-07:00) PST8PDT" },
    { id: 36, name: "(GMT-06:00) America/Belize" },
    { id: 37, name: "(GMT-06:00) America/Boise" },
    { id: 38, name: "(GMT-06:00) America/Cambridge Bay" },
    { id: 39, name: "(GMT-06:00) America/Chihuahua" },
    { id: 40, name: "(GMT-06:00) America/Costa Rica" },
    { id: 41, name: "(GMT-06:00) America/Denver" },
    { id: 42, name: "(GMT-06:00) America/Edmonton" },
    { id: 43, name: "(GMT-06:00) America/El Salvador" },
    { id: 44, name: "(GMT-06:00) America/Guatemala" },
    { id: 45, name: "(GMT-06:00) America/Inuvik" },
    { id: 46, name: "(GMT-06:00) America/Managua" },
    { id: 47, name: "(GMT-06:00) America/Mazatlan" },
    { id: 48, name: "(GMT-06:00) America/Ojinaga" },
    { id: 49, name: "(GMT-06:00) America/Regina" },
    { id: 50, name: "(GMT-06:00) America/Swift Current" },
    { id: 51, name: "(GMT-06:00) America/Tegucigalpa" },
    { id: 52, name: "(GMT-06:00) America/Yellowknife" },
    { id: 53, name: "(GMT-06:00) Etc/GMT+6" },
    { id: 54, name: "(GMT-06:00) MST7MDT" },
    { id: 55, name: "(GMT-06:00) Pacific/Easter" },
    { id: 56, name: "(GMT-06:00) Pacific/Galapagos" },
    { id: 57, name: "(GMT-05:00) America/Atikokan" },
    { id: 58, name: "(GMT-05:00) America/Bahia Banderas" },
    { id: 59, name: "(GMT-05:00) America/Bogota" },
    { id: 60, name: "(GMT-05:00) America/Cancun" },
    { id: 61, name: "(GMT-05:00) America/Cayman" },
    { id: 62, name: "(GMT-05:00) America/Chicago" },
    { id: 63, name: "(GMT-05:00) America/Eirunepe" },
    { id: 64, name: "(GMT-05:00) America/Guayaquil" },
    { id: 65, name: "(GMT-05:00) America/Indiana/Knox" },
    { id: 66, name: "(GMT-05:00) America/Indiana/Tell City" },
    { id: 67, name: "(GMT-05:00) America/Jamaica" },
    { id: 68, name: "(GMT-05:00) America/Lima" },
    { id: 69, name: "(GMT-05:00) America/Matamoros" },
    { id: 70, name: "(GMT-05:00) America/Menominee" },
    { id: 71, name: "(GMT-05:00) America/Merida" },
    { id: 72, name: "(GMT-05:00) America/Mexico City" },
    { id: 73, name: "(GMT-05:00) America/Monterrey" },
    { id: 74, name: "(GMT-05:00) America/North Dakota/Beulah" },
    { id: 75, name: "(GMT-05:00) America/North Dakota/Center" },
    { id: 76, name: "(GMT-05:00) America/North Dakota/New_Salem" },
    { id: 77, name: "(GMT-05:00) America/Panama" },
    { id: 78, name: "(GMT-05:00) America/Rainy River" },
    { id: 79, name: "(GMT-05:00) America/Rankin Inlet" },
    { id: 80, name: "(GMT-05:00) America/Resolute" },
    { id: 81, name: "(GMT-05:00) America/Rio Branco" },
    { id: 82, name: "(GMT-05:00) America/Winnipeg" },
    { id: 83, name: "(GMT-05:00) CST6CDT" },
    { id: 84, name: "(GMT-05:00) EST" },
    { id: 85, name: "(GMT-05:00) Etc/GMT+5" },
    { id: 86, name: "(GMT-04:00) America/Anguilla" },
    { id: 87, name: "(GMT-04:00) America/Antigua" },
    { id: 88, name: "(GMT-04:00) America/Aruba" },
    { id: 89, name: "(GMT-04:00) America/Asuncion" },
    { id: 90, name: "(GMT-04:00) America/Barbados" },
    { id: 91, name: "(GMT-04:00) America/Blanc-Sablon" },
    { id: 92, name: "(GMT-04:00) America/Boa Vista" },
    { id: 93, name: "(GMT-04:00) America/Campo Grande" },
    { id: 94, name: "(GMT-04:00) America/Caracas" },
    { id: 95, name: "(GMT-04:00) America/Cuiaba" },
    { id: 96, name: "(GMT-04:00) America/Curacao" },
    { id: 97, name: "(GMT-04:00) America/Detroit" },
    { id: 98, name: "(GMT-04:00) America/Dominica" },
    { id: 99, name: "(GMT-04:00) America/Grand Turk" },
    { id: 100, name: "(GMT-04:00) America/Grenada" },
    { id: 101, name: "(GMT-04:00) America/Guadeloupe" },
    { id: 102, name: "(GMT-04:00) America/Guyana" },
    { id: 103, name: "(GMT-04:00) America/Havana" },
    { id: 104, name: "(GMT-04:00) America/Indiana/Indianapolis" },
    { id: 105, name: "(GMT-04:00) America/Indiana/Marengo" },
    { id: 106, name: "(GMT-04:00) America/Indiana/Petersburg" },
    { id: 107, name: "(GMT-04:00) America/Indiana/Vevay" },
    { id: 108, name: "(GMT-04:00) America/Indiana/Vincennes" },
    { id: 109, name: "(GMT-04:00) America/Indianapolis" },
    { id: 110, name: "(GMT-04:00) America/Iqaluit" },
    { id: 111, name: "(GMT-04:00) America/Kentucky/Louisville" },
    { id: 112, name: "(GMT-04:00) America/Kentucky/Monticello" },
    { id: 113, name: "(GMT-04:00) America/Indiana/Winamac" },
    { id: 114, name: "(GMT-04:00) America/Kralendijk" },
    { id: 115, name: "(GMT-04:00) America/La Paz" },
    { id: 116, name: "(GMT-04:00) America/Lower Princes" },
    { id: 117, name: "(GMT-04:00) America/Manaus" },
    { id: 118, name: "(GMT-04:00) America/Marigot" },
    { id: 119, name: "(GMT-04:00) America/Martinique" },
    { id: 120, name: "(GMT-04:00) America/Montreal" },
    { id: 121, name: "(GMT-04:00) America/Montserrat" },
    { id: 122, name: "(GMT-04:00) America/Nassau" },
    { id: 123, name: "(GMT-04:00) America/New York" },
    { id: 124, name: "(GMT-04:00) America/Nipigon" },
    { id: 125, name: "(GMT-04:00) America/Pangnirtung" },
    { id: 126, name: "(GMT-04:00) America/Port-au-Prince" },
    { id: 127, name: "(GMT-04:00) America/Port of_Spain" },
    { id: 128, name: "(GMT-04:00) America/Porto Velho" },
    { id: 129, name: "(GMT-04:00) America/Puerto Rico" },
    { id: 130, name: "(GMT-04:00) America/Santiago" },
    { id: 131, name: "(GMT-04:00) America/Santo Domingo" },
    { id: 132, name: "(GMT-04:00) America/St Barthelemy" },
    { id: 133, name: "(GMT-04:00) America/St Kitts" },
    { id: 134, name: "(GMT-04:00) America/St Lucia" },
    { id: 135, name: "(GMT-04:00) America/St Thomas" },
    { id: 136, name: "(GMT-04:00) America/St Vincent" },
    { id: 137, name: "(GMT-04:00) America/Thunder Bay" },
    { id: 138, name: "(GMT-04:00) America/Toronto" },
    { id: 139, name: "(GMT-04:00) America/Tortola" },
    { id: 140, name: "(GMT-04:00) EST5EDT" },
    { id: 141, name: "(GMT-04:00) Etc/GMT+4" },
    { id: 142, name: "(GMT-03:00) America/Araguaina" },
    { id: 143, name: "(GMT-03:00) America/Argentina/Buenos Aires" },
    { id: 144, name: "(GMT-03:00) America/Argentina/Catamarca" },
    { id: 145, name: "(GMT-03:00) America/Argentina/Cordoba" },
    { id: 146, name: "(GMT-03:00) America/Argentina/Jujuy" },
    { id: 147, name: "(GMT-03:00) America/Argentina/La Rioja" },
    { id: 148, name: "(GMT-03:00) America/Argentina/Mendoza" },
    { id: 149, name: "(GMT-03:00) America/Argentina/Rio Gallegos" },
    { id: 150, name: "(GMT-03:00) America/Argentina/Salta" },
    { id: 151, name: "(GMT-03:00) America/Argentina/San Juan" },
    { id: 152, name: "(GMT-03:00) America/Argentina/San Luis" },
    { id: 153, name: "(GMT-03:00) America/Argentina/Tucuman" },
    { id: 154, name: "(GMT-03:00) America/Argentina/Ushuaia" },
    { id: 155, name: "(GMT-03:00) America/Bahia" },
    { id: 156, name: "(GMT-03:00) America/Belem" },
    { id: 157, name: "(GMT-03:00) America/Cayenne" },
    { id: 158, name: "(GMT-03:00) America/Fortaleza" },
    { id: 159, name: "(GMT-03:00) America/Glace Bay" },
    { id: 160, name: "(GMT-03:00) America/Goose Bay" },
    { id: 161, name: "(GMT-03:00) America/Halifax" },
    { id: 162, name: "(GMT-03:00) America/Maceio" },
    { id: 163, name: "(GMT-03:00) America/Moncton" },
    { id: 164, name: "(GMT-03:00) America/Montevideo" },
    { id: 165, name: "(GMT-03:00) America/Paramaribo" },
    { id: 166, name: "(GMT-03:00) America/Punta Arenas" },
    { id: 167, name: "(GMT-03:00) America/Recife" },
    { id: 168, name: "(GMT-03:00) America/Santarem" },
    { id: 169, name: "(GMT-03:00) America/Sao Paulo" },
    { id: 170, name: "(GMT-03:00) America/Thule" },
    { id: 171, name: "(GMT-03:00) Antarctica/Palmer" },
    { id: 172, name: "(GMT-03:00) Antarctica/Rothera" },
    { id: 173, name: "(GMT-03:00) Atlantic/Bermuda" },
    { id: 174, name: "(GMT-03:00) Atlantic/Stanley" },
    { id: 175, name: "(GMT-03:00) Etc/GMT+3" },
    { id: 176, name: "(GMT-02:30) America/St Johns" },
    { id: 177, name: "(GMT-02:00) America/Godthab" },
    { id: 178, name: "(GMT-02:00) America/Miquelon" },
    { id: 179, name: "(GMT-02:00) America/Noronha" },
    { id: 180, name: "(GMT-02:00) America/Nuuk" },
    { id: 181, name: "(GMT-02:00) Atlantic/South Georgia" },
    { id: 182, name: "(GMT-02:00) Etc/GMT+2" },
    { id: 183, name: "(GMT-01:00) Atlantic/Cape Verde" },
    { id: 184, name: "(GMT-01:00) Etc/GMT+1" },
    { id: 185, name: "(GMT+00:00) Africa/Abidjan" },
    { id: 186, name: "(GMT+00:00) Africa/Accra" },
    { id: 187, name: "(GMT+00:00) Africa/Bamako" },
    { id: 188, name: "(GMT+00:00) Africa/Banjul" },
    { id: 189, name: "(GMT+00:00) Africa/Bissau" },
    { id: 190, name: "(GMT+00:00) Africa/Conakry" },
    { id: 191, name: "(GMT+00:00) Africa/Dakar" },
    { id: 192, name: "(GMT+00:00) Africa/Freetown" },
    { id: 193, name: "(GMT+00:00) Africa/Lome" },
    { id: 194, name: "(GMT+00:00) Africa/Monrovia" },
    { id: 195, name: "(GMT+00:00) Africa/Nouakchott" },
    { id: 196, name: "(GMT+00:00) Africa/Ouagadougou" },
    { id: 197, name: "(GMT+00:00) Africa/Sao Tome" },
    { id: 198, name: "(GMT+00:00) America/Danmarkshavn" },
    { id: 199, name: "(GMT+00:00) America/Scoresbysund" },
    { id: 200, name: "(GMT+00:00) Atlantic/Azores" },
    { id: 201, name: "(GMT+00:00) Atlantic/Reykjavik" },
    { id: 202, name: "(GMT+00:00) Atlantic/St Helena" },
    { id: 203, name: "(GMT+00:00) Etc/GMT" },
    { id: 204, name: "(GMT+00:00) Etc/GMT+0" },
    { id: 205, name: "(GMT+00:00) Etc/GMT-0" },
    { id: 206, name: "(GMT+00:00) Etc/GMT0" },
    { id: 207, name: "(GMT+00:00) Etc/Greenwich" },
    { id: 208, name: "(GMT+00:00) Etc/Universal" },
    { id: 209, name: "(GMT+00:00) Etc/Zulu" },
    { id: 210, name: "(GMT+00:00) GMT" },
    { id: 211, name: "(GMT+00:00) UTC" },
    { id: 212, name: "(GMT+01:00) Africa/Algiers" },
    { id: 213, name: "(GMT+01:00) Africa/Bangui" },
    { id: 214, name: "(GMT+01:00) Africa/Brazzaville" },
    { id: 215, name: "(GMT+01:00) Africa/Casablanca" },
    { id: 216, name: "(GMT+01:00) Africa/Douala" },
    { id: 217, name: "(GMT+01:00) Africa/El Aaiun" },
    { id: 218, name: "(GMT+01:00) Africa/Kinshasa" },
    { id: 219, name: "(GMT+01:00) Africa/Lagos" },
    { id: 220, name: "(GMT+01:00) Africa/Libreville" },
    { id: 221, name: "(GMT+01:00) Africa/Luanda" },
    { id: 222, name: "(GMT+01:00) Africa/Malabo" },
    { id: 223, name: "(GMT+01:00) Africa/Ndjamena" },
    { id: 224, name: "(GMT+01:00) Africa/Niamey" },
    { id: 225, name: "(GMT+01:00) Africa/Porto-Novo" },
    { id: 226, name: "(GMT+01:00) Africa/Tunis" },
    { id: 227, name: "(GMT+01:00) Atlantic/Canary" },
    { id: 228, name: "(GMT+01:00) Atlantic/Faroe" },
    { id: 229, name: "(GMT+01:00) Atlantic/Madeira" },
    { id: 230, name: "(GMT+01:00) Etc/GMT-1" },
    { id: 231, name: "(GMT+01:00) Europe/Dublin" },
    { id: 232, name: "(GMT+01:00) Europe/Guernsey" },
    { id: 233, name: "(GMT+01:00) Europe/Isle of_Man" },
    { id: 234, name: "(GMT+01:00) Europe/Jersey" },
    { id: 235, name: "(GMT+01:00) Europe/Lisbon" },
    { id: 236, name: "(GMT+01:00) Europe/London" },
    { id: 237, name: "(GMT+01:00) WET" },
    { id: 238, name: "(GMT+02:00) Africa/Blantyre" },
    { id: 239, name: "(GMT+02:00) Africa/Bujumbura" },
    { id: 240, name: "(GMT+02:00) Africa/Cairo" },
    { id: 241, name: "(GMT+02:00) Africa/Ceuta" },
    { id: 242, name: "(GMT+02:00) Africa/Gaborone" },
    { id: 243, name: "(GMT+02:00) Africa/Harare" },
    { id: 244, name: "(GMT+02:00) Africa/Johannesburg" },
    { id: 245, name: "(GMT+02:00) Africa/Juba" },
    { id: 246, name: "(GMT+02:00) Africa/Khartoum" },
    { id: 247, name: "(GMT+02:00) Africa/Kigali" },
    { id: 248, name: "(GMT+02:00) Africa/Lubumbashi" },
    { id: 249, name: "(GMT+02:00) Africa/Lusaka" },
    { id: 250, name: "(GMT+02:00) Africa/Maputo" },
    { id: 251, name: "(GMT+02:00) Africa/Maseru" },
    { id: 252, name: "(GMT+02:00) Africa/Mbabane" },
    { id: 253, name: "(GMT+02:00) Africa/Tripoli" },
    { id: 254, name: "(GMT+02:00) Africa/Windhoek" },
    { id: 255, name: "(GMT+02:00) Antarctica/Troll" },
    { id: 256, name: "(GMT+02:00) Arctic/Longyearbyen" },
    { id: 257, name: "(GMT+02:00) CET" },
    { id: 258, name: "(GMT+02:00) Etc/GMT-2" },
    { id: 259, name: "(GMT+02:00) Europe/Amsterdam" },
    { id: 260, name: "(GMT+02:00) Europe/Andorra" },
    { id: 261, name: "(GMT+02:00) Europe/Belgrade" },
    { id: 262, name: "(GMT+02:00) Europe/Berlin" },
    { id: 263, name: "(GMT+02:00) Europe/Bratislava" },
    { id: 264, name: "(GMT+02:00) Europe/Brussels" },
    { id: 265, name: "(GMT+02:00) Europe/Budapest" },
    { id: 266, name: "(GMT+02:00) Europe/Busingen" },
    { id: 267, name: "(GMT+02:00) Europe/Copenhagen" },
    { id: 268, name: "(GMT+02:00) Europe/Gibraltar" },
    { id: 269, name: "(GMT+02:00) Europe/Kaliningrad" },
    { id: 270, name: "(GMT+02:00) Europe/Ljubljana" },
    { id: 271, name: "(GMT+02:00) Europe/Luxembourg" },
    { id: 272, name: "(GMT+02:00) Europe/Madrid" },
    { id: 273, name: "(GMT+02:00) Europe/Malta" },
    { id: 274, name: "(GMT+02:00) Europe/Monaco" },
    { id: 275, name: "(GMT+02:00) Europe/Oslo" },
    { id: 276, name: "(GMT+02:00) Europe/Paris" },
    { id: 277, name: "(GMT+02:00) Europe/Podgorica" },
    { id: 278, name: "(GMT+02:00) Europe/Prague" },
    { id: 279, name: "(GMT+02:00) Europe/Rome" },
    { id: 280, name: "(GMT+02:00) Europe/San Marino" },
    { id: 281, name: "(GMT+02:00) Europe/Sarajevo" },
    { id: 282, name: "(GMT+02:00) Europe/Skopje" },
    { id: 283, name: "(GMT+02:00) Europe/Stockholm" },
    { id: 284, name: "(GMT+02:00) Europe/Tirane" },
    { id: 285, name: "(GMT+02:00) Europe/Vaduz" },
    { id: 286, name: "(GMT+02:00) Europe/Vatican" },
    { id: 287, name: "(GMT+02:00) Europe/Vienna" },
    { id: 288, name: "(GMT+02:00) Europe/Warsaw" },
    { id: 289, name: "(GMT+02:00) Europe/Zagreb" },
    { id: 290, name: "(GMT+02:00) Europe/Zurich" },
    { id: 291, name: "(GMT+02:00) MET" },
    { id: 292, name: "(GMT+03:00) Africa/Addis Ababa" },
    { id: 293, name: "(GMT+03:00) Africa/Asmara" },
    { id: 294, name: "(GMT+03:00) Africa/Dar es_Salaam" },
    { id: 295, name: "(GMT+03:00) Africa/Djibouti" },
    { id: 296, name: "(GMT+03:00) Africa/Kampala" },
    { id: 297, name: "(GMT+03:00) Africa/Mogadishu" },
    { id: 298, name: "(GMT+03:00) Africa/Nairobi" },
    { id: 299, name: "(GMT+03:00) Antarctica/Syowa" },
    { id: 300, name: "(GMT+03:00) Asia/Aden" },
    { id: 301, name: "(GMT+03:00) Asia/Amman" },
    { id: 302, name: "(GMT+03:00) Asia/Baghdad" },
    { id: 303, name: "(GMT+03:00) Asia/Bahrain" },
    { id: 304, name: "(GMT+03:00) Asia/Beirut" },
    { id: 305, name: "(GMT+03:00) Asia/Damascus" },
    { id: 306, name: "(GMT+03:00) Asia/Famagusta" },
    { id: 307, name: "(GMT+03:00) Asia/Gaza" },
    { id: 308, name: "(GMT+03:00) Asia/Hebron" },
    { id: 309, name: "(GMT+03:00) Asia/Istanbul" },
    { id: 310, name: "(GMT+03:00) Asia/Jerusalem" },
    { id: 311, name: "(GMT+03:00) Asia/Kuwait" },
    { id: 312, name: "(GMT+03:00) Asia/Nicosia" },
    { id: 313, name: "(GMT+03:00) Asia/Qatar" },
    { id: 314, name: "(GMT+03:00) Asia/Riyadh" },
    { id: 315, name: "(GMT+03:00) EET" },
    { id: 316, name: "(GMT+03:00) Etc/GMT-3" },
    { id: 317, name: "(GMT+03:00) Europe/Athens" },
    { id: 318, name: "(GMT+03:00) Europe/Bucharest" },
    { id: 319, name: "(GMT+03:00) Europe/Chisinau" },
    { id: 320, name: "(GMT+03:00) Europe/Helsinki" },
    { id: 321, name: "(GMT+03:00) Europe/Istanbul" },
    { id: 322, name: "(GMT+03:00) Europe/Kiev" },
    { id: 323, name: "(GMT+03:00) Europe/Kirov" },
    { id: 324, name: "(GMT+03:00) Europe/Mariehamn" },
    { id: 325, name: "(GMT+03:00) Europe/Minsk" },
    { id: 326, name: "(GMT+03:00) Europe/Moscow" },
    { id: 327, name: "(GMT+03:00) Europe/Nicosia" },
    { id: 328, name: "(GMT+03:00) Europe/Riga" },
    { id: 329, name: "(GMT+03:00) Europe/Simferopol" },
    { id: 330, name: "(GMT+03:00) Europe/Sofia" },
    { id: 331, name: "(GMT+03:00) Europe/Tallinn" },
    { id: 332, name: "(GMT+03:00) Europe/Uzhgorod" },
    { id: 333, name: "(GMT+03:00) Europe/Vilnius" },
    { id: 334, name: "(GMT+03:00) Europe/Volgograd" },
    { id: 335, name: "(GMT+03:00) Europe/Zaporozhye" },
    { id: 336, name: "(GMT+03:00) Indian/Antananarivo" },
    { id: 337, name: "(GMT+03:00) Indian/Comoro" },
    { id: 338, name: "(GMT+03:00) Indian/Mayotte" },
    { id: 339, name: "(GMT+04:00) Asia/Baku" },
    { id: 340, name: "(GMT+04:00) Asia/Dubai" },
    { id: 341, name: "(GMT+04:00) Asia/Muscat" },
    { id: 342, name: "(GMT+04:00) Asia/Tbilisi" },
    { id: 343, name: "(GMT+04:00) Asia/Yerevan" },
    { id: 344, name: "(GMT+04:00) Etc/GMT-4" },
    { id: 345, name: "(GMT+04:00) Europe/Astrakhan" },
    { id: 346, name: "(GMT+04:00) Europe/Samara" },
    { id: 347, name: "(GMT+04:00) Europe/Saratov" },
    { id: 348, name: "(GMT+04:00) Europe/Ulyanovsk" },
    { id: 349, name: "(GMT+04:00) Indian/Mahe" },
    { id: 350, name: "(GMT+04:00) Indian/Mauritius" },
    { id: 351, name: "(GMT+04:00) Indian/Reunion" },
    { id: 352, name: "(GMT+04:30) Asia/Kabul" },
    { id: 353, name: "(GMT+04:30) Asia/Tehran" },
    { id: 354, name: "(GMT+05:00) Antarctica/Mawson" },
    { id: 355, name: "(GMT+05:00) Asia/Aqtau" },
    { id: 356, name: "(GMT+05:00) Asia/Aqtobe" },
    { id: 357, name: "(GMT+05:00) Asia/Ashgabat" },
    { id: 358, name: "(GMT+05:00) Asia/Atyrau" },
    { id: 359, name: "(GMT+05:00) Asia/Dushanbe" },
    { id: 360, name: "(GMT+05:00) Asia/Karachi" },
    { id: 361, name: "(GMT+05:00) Asia/Oral" },
    { id: 362, name: "(GMT+05:00) Asia/Qyzylorda" },
    { id: 363, name: "(GMT+05:00) Asia/Samarkand" },
    { id: 364, name: "(GMT+05:00) Asia/Tashkent" },
    { id: 365, name: "(GMT+05:00) Asia/Yekaterinburg" },
    { id: 366, name: "(GMT+05:00) Etc/GMT-5" },
    { id: 367, name: "(GMT+05:00) Indian/Kerguelen" },
    { id: 368, name: "(GMT+05:00) Indian/Maldives" },
    { id: 369, name: "(GMT+05:30) Asia/Calcutta" },
    { id: 370, name: "(GMT+05:30) Asia/Colombo" },
    { id: 371, name: "(GMT+05:30) Asia/Kolkata" },
    { id: 372, name: "(GMT+05:45) Asia/Kathmandu" },
    { id: 373, name: "(GMT+05:45) Asia/Katmandu" },
    { id: 374, name: "(GMT+06:00) Antarctica/Vostok" },
    { id: 375, name: "(GMT+06:00) Asia/Almaty" },
    { id: 376, name: "(GMT+06:00) Asia/Bishkek" },
    { id: 377, name: "(GMT+06:00) Asia/Dhaka" },
    { id: 378, name: "(GMT+06:00) Asia/Omsk" },
    { id: 379, name: "(GMT+06:00) Asia/Qostanay" },
    { id: 380, name: "(GMT+06:00) Asia/Thimphu" },
    { id: 381, name: "(GMT+06:00) Asia/Urumqi" },
    { id: 382, name: "(GMT+06:00) Etc/GMT-6" },
    { id: 383, name: "(GMT+06:00) Indian/Chagos" },
    { id: 384, name: "(GMT+06:30) Asia/Yangon" },
    { id: 385, name: "(GMT+06:30) Indian/Cocos" },
    { id: 386, name: "(GMT+07:00) Antarctica/Davis" },
    { id: 387, name: "(GMT+07:00) Asia/Bangkok" },
    { id: 388, name: "(GMT+07:00) Asia/Barnaul" },
    { id: 389, name: "(GMT+07:00) Asia/Ho Chi_Minh" },
    { id: 390, name: "(GMT+07:00) Asia/Hovd" },
    { id: 391, name: "(GMT+07:00) Asia/Jakarta" },
    { id: 392, name: "(GMT+07:00) Asia/Krasnoyarsk" },
    { id: 393, name: "(GMT+07:00) Asia/Novokuznetsk" },
    { id: 394, name: "(GMT+07:00) Asia/Novosibirsk" },
    { id: 395, name: "(GMT+07:00) Asia/Phnom Penh" },
    { id: 396, name: "(GMT+07:00) Asia/Pontianak" },
    { id: 397, name: "(GMT+07:00) Asia/Tomsk" },
    { id: 398, name: "(GMT+07:00) Asia/Vientiane" },
    { id: 399, name: "(GMT+07:00) Etc/GMT-7" },
    { id: 400, name: "(GMT+07:00) Indian/Christmas" },
    { id: 401, name: "(GMT+08:00) Asia/Brunei" },
    { id: 402, name: "(GMT+08:00) Asia/Choibalsan" },
    { id: 403, name: "(GMT+08:00) Asia/Hong Kong" },
    { id: 404, name: "(GMT+08:00) Asia/Irkutsk" },
    { id: 405, name: "(GMT+08:00) Asia/Kuala Lumpur" },
    { id: 406, name: "(GMT+08:00) Asia/Kuching" },
    { id: 407, name: "(GMT+08:00) Asia/Macau" },
    { id: 408, name: "(GMT+08:00) Asia/Makassar" },
    { id: 409, name: "(GMT+08:00) Asia/Manila" },
    { id: 410, name: "(GMT+08:00) Asia/Shanghai" },
    { id: 411, name: "(GMT+08:00) Asia/Singapore" },
    { id: 412, name: "(GMT+08:00) Asia/Taipei" },
    { id: 413, name: "(GMT+08:00) Asia/Ulaanbaatar" },
    { id: 414, name: "(GMT+08:00) Australia/Perth" },
    { id: 415, name: "(GMT+08:00) Etc/GMT-8" },
    { id: 416, name: "(GMT+08:45) Australia/Eucla" },
    { id: 417, name: "(GMT+09:00) Asia/Chita" },
    { id: 418, name: "(GMT+09:00) Asia/Dili" },
    { id: 419, name: "(GMT+09:00) Asia/Jayapura" },
    { id: 420, name: "(GMT+09:00) Asia/Khandyga" },
    { id: 421, name: "(GMT+09:00) Asia/Pyongyang" },
    { id: 422, name: "(GMT+09:00) Asia/Seoul" },
    { id: 423, name: "(GMT+09:00) Asia/Tokyo" },
    { id: 424, name: "(GMT+09:00) Asia/Yakutsk" },
    { id: 425, name: "(GMT+09:00) Etc/GMT-9" },
    { id: 426, name: "(GMT+09:00) Pacific/Palau" },
    { id: 427, name: "(GMT+09:30) Australia/Adelaide" },
    { id: 428, name: "(GMT+09:30) Australia/Broken Hill" },
    { id: 429, name: "(GMT+09:30) Australia/Darwin" },
    { id: 430, name: "(GMT+10:00) Antarctica/DumontDUrville" },
    { id: 431, name: "(GMT+10:00) Antarctica/Macquarie" },
    { id: 432, name: "(GMT+10:00) Asia/Ust-Nera" },
    { id: 433, name: "(GMT+10:00) Asia/Vladivostok" },
    { id: 434, name: "(GMT+10:00) Australia/Brisbane" },
    { id: 435, name: "(GMT+10:00) Australia/Currie" },
    { id: 436, name: "(GMT+10:00) Australia/Hobart" },
    { id: 437, name: "(GMT+10:00) Australia/Lindeman" },
    { id: 438, name: "(GMT+10:00) Australia/Melbourne" },
    { id: 439, name: "(GMT+10:00) Australia/Sydney" },
    { id: 440, name: "(GMT+10:00) Etc/GMT-10" },
    { id: 441, name: "(GMT+10:00) Pacific/Chuuk" },
    { id: 442, name: "(GMT+10:00) Pacific/Guam" },
    { id: 443, name: "(GMT+10:00) Pacific/Port Moresby" },
    { id: 444, name: "(GMT+10:00) Pacific/Saipan" },
    { id: 445, name: "(GMT+10:30) Australia/Lord Howe" },
    { id: 446, name: "(GMT+11:00) Antarctica/Casey" },
    { id: 447, name: "(GMT+11:00) Asia/Magadan" },
    { id: 448, name: "(GMT+11:00) Asia/Sakhalin" },
    { id: 449, name: "(GMT+11:00) Asia/Srednekolymsk" },
    { id: 450, name: "(GMT+11:00) Etc/GMT-11" },
    { id: 451, name: "(GMT+11:00) Pacific/Bougainville" },
    { id: 452, name: "(GMT+11:00) Pacific/Efate" },
    { id: 453, name: "(GMT+11:00) Pacific/Guadalcanal" },
    { id: 454, name: "(GMT+11:00) Pacific/Kosrae" },
    { id: 455, name: "(GMT+11:00) Pacific/Norfolk" },
    { id: 456, name: "(GMT+11:00) Pacific/Noumea" },
    { id: 457, name: "(GMT+11:00) Pacific/Pohnpei" },
    { id: 458, name: "(GMT+12:00) Antarctica/McMurdo" },
    { id: 459, name: "(GMT+12:00) Asia/Anadyr" },
    { id: 460, name: "(GMT+12:00) Asia/Kamchatka" },
    { id: 461, name: "(GMT+12:00) Etc/GMT-12" },
    { id: 462, name: "(GMT+12:00) Pacific/Auckland" },
    { id: 463, name: "(GMT+12:00) Pacific/Fiji" },
    { id: 464, name: "(GMT+12:00) Pacific/Funafuti" },
    { id: 465, name: "(GMT+12:00) Pacific/Kwajalein" },
    { id: 466, name: "(GMT+12:00) Pacific/Majuro" },
    { id: 467, name: "(GMT+12:00) Pacific/Nauru" },
    { id: 468, name: "(GMT+12:00) Pacific/Tarawa" },
    { id: 469, name: "(GMT+12:00) Pacific/Wake" },
    { id: 470, name: "(GMT+12:00) Pacific/Wallis" },
    { id: 471, name: "(GMT+12:45) Pacific/Chatham" },
    { id: 472, name: "(GMT+13:00) Etc/GMT-13" },
    { id: 473, name: "(GMT+13:00) Pacific/Apia" },
    { id: 474, name: "(GMT+13:00) Pacific/Enderbury" },
    { id: 475, name: "(GMT+13:00) Pacific/Fakaofo" },
    { id: 476, name: "(GMT+13:00) Pacific/Tongatapu" },
    { id: 477, name: "(GMT+14:00) Etc/GMT-14" },
    { id: 478, name: "(GMT+14:00) Pacific/Kiritimati" },
  ];

  startclear: boolean = false;
  countzero: boolean = false;
  countactiveusers: any = 0;
  negativechoosen: boolean = false;
  monthsexceeded: boolean = false;
  m12: any;
  m11: any;
  numberOfMonths: number;
  chart: AmChart;
  chartReceived: AmChart;
  templateChart: AmChart;
  sentChartOptions = {
    type: "serial",
    theme: "none",
    dataProvider: [],
    valueAxes: [
      {
        gridColor: "#FFFFFF",
        gridAlpha: 0.2,
        dashLength: 0,
        minimum: 0,
      },
    ],
    gridAboveGraphs: true,
    startDuration: 1,
    graphs: [
      {
        balloonText: "[[category]]: <b>[[value]]</b>",
        fillAlphas: 0.8,
        lineAlpha: 0.2,
        type: "column",
        valueField: "value",
        fillColors: ["#1E87F0", "#40BCF9"],
        fixedColumnWidth: 30,
      },
    ],
    chartCursor: {
      categoryBalloonEnabled: false,
      cursorAlpha: 0,
      zoomable: false,
    },
    categoryField: "month",
    categoryAxis: {
      gridPosition: "start",
      gridAlpha: 0,
      tickPosition: "start",
      tickLength: 20,
      labelPosition: "middle",
      labelRotation: 45,
    },
    export: {
      enabled: true,
    },
  };
  monthSelect = [
    { name: "January" },
    { name: "February" },
    { name: "March" },
    { name: "April" },
    { name: "May" },
    { name: "June" },
    { name: "July" },
    { name: "August" },
    { name: "September" },
    { name: "October" },
    { name: "November" },
    { name: "December" },
  ];
  monthSelect2 = [
    { name: "January" },
    { name: "February" },
    { name: "March" },
    { name: "April" },
    { name: "May" },
    { name: "June" },
    { name: "July" },
    { name: "August" },
    { name: "September" },
    { name: "October" },
    { name: "November" },
    { name: "December" },
  ];
  check21: any;
  check11: any;
  m0: any;
  m1: any;
  m2: any;
  m3: any;
  m4: any;
  m5: any;
  m6: any;
  m7: any;
  m8: any;
  m9: any;
  m10: any;
  fm0: any;
  fm1: any;
  fm2: any;
  fm3: any;
  fm4: any;
  fm5: any;
  fm6: any;
  fm7: any;
  fm8: any;
  fm9: any;
  fm10: any;
  fm11: any;
  fm12: any;

  monthForm2 = new FormGroup({
    monthcontrol2: new FormControl(""),
  });
  yearForm = new FormGroup({
    yearcontrol: new FormControl(""),
  });
  yearForm2 = new FormGroup({
    yearcontrol2: new FormControl(""),
  });
  monthForm = new FormGroup({
    monthcontrol: new FormControl(""),
  });
  whatsappConnecterAdded: boolean;
  whatsappCloudConnecterAdded: boolean;
  audioDurationLoad:boolean = false;
  noRecords: boolean = true;
  month20: any;
  fromMonthActive: any;
  fromYearActive: any;
  toMonthActive: any;
  toYearActive: any;
  dashboardChartDetails: any;
  monthfromActive: any;
  monthfromActive1: any;
  formattedfromActive: any;
  yearfromActive: any;
  yearfromActive1: any;
  yearfromActive2: number = 0;
  yearfromActive3: number = 0;
  formattedMonth1;
  monthtoActive: any;
  monthtoActive1: any;
  formattedtoActive: any;
  yeartoActivepreviousmonth: any;
  yeartoActive: any;
  yeartoActive4: any;
  yeartoActive1: any;
  activemonthlyusersboolean: boolean = false;
  activeMonthlyUsers1: any;
  activeboolean: boolean = false;
  applId: any;
  m: any;
  y: any;
  check: any;
  month: any;
  monthName: any = [];
  year: any;
  year1: any;
  year2: any;
  yearSelect: any = [];
  yearSelect1: any = [];
  yearSubtract: any = 0;
  todaysDate: any = moment();
  applicationList: [];
  applicationContent: any;
  isEditApplication = false;
  isEditApplicationURLHandle = false;
  isEditApplicationDescription = false;
  countDetails: any;
  addConnectorDetails: any = [];
  connectorDetails: any = [];
  connecter: boolean = true;
  userData: any;
  applicationDetails: any;
  selectedIndex: number = 0;
  maxNumberOfTabs: number = 4;
  backButtonDisable: boolean = true;
  nextButtonDisable: boolean = true;
  tabName: string = "Connector";
  tooltipContent: string;
  botIdRequiredError: string;
  urlRequiredError: string;
  appNameRequiredError: string;
  botId: any;
  registrationUrl: any;
  applicationName: any;
  applicationDescription: any;
  selectedConnector: any;
  selectedConnectorDetails: any;
  appKeyRequiredError: string;
  appSecretRequiredError: string;
  templateDetails: any = "";
  appKey: any;
  appURLHandle: any;
  appSecret: any;
  botDetailsId: any;
  registerUrl: any;
  oldValue: string;
  botDetailsIdRequiredError: string;
  registerUrlRequiredError: string;
  webhookValidateError: string;
  displayNext: string = "block";
  display: string = "none";
  headerLength: number = 0;
  headerArray = [];
  totalCountDetails: any;
  userCountClick: boolean = false;
  updateApplicationLoader: boolean = false;
  updateApplicationURLHandleLoader: boolean = false;
  loadershow: boolean = false;
  messageSentClick: boolean = false;
  messageReceivedClick: boolean = false;
  connectorMsgSentClick: boolean = false;
  connectorHsmMsgSentClick: boolean = false;
  receivedNotificationClick: boolean = false;
  audiototextClick: boolean = false;
  tempalteCoClick: boolean = false;
  bsValue = new Date();
  bsRangeValue: Date[];
  toDate: any = moment();
  fromDate: any = moment().subtract(30, "days");
  dateRangeDiv: boolean = false;
  dateRangeCount: any;
  currentOpenConnectorId: string;
  delconfirm: any;
  delconfirmapp: any;
  callbackper: boolean = false;
  languageTranslate: any;
  updateCustomerIdStatus: boolean = false;
  optionalParamsValue = {
    value: [],
  };
  audioYearlyCount:any
  audioMonthlyCount:any
  audioWeeklyCount:any
  audioTodayCount:any
  clickedItem: any;
  templateObject: any;
  templateConnectors:any =[];
  templateKey: any;
  topPosToStartShowing = 100;
  showSuccess: boolean = false;
  enabilecheckbox: boolean = true;
  resTranslationCount = [];
  selectedTranslationLanguage: string;
  callBackPersistCount: number;
  applicationId: string;
  totalSentMessages: number;
  activeMonthlyUsers: number;
  totalTemplate: number;
  totalSentMessageLoader: boolean;
  activeMonthlyUsersLoader: boolean;
  audioReceivedTotalDurationLoader:boolean
  totalTempalteLoader: boolean = true;
  totalReceivedMessages: number;
  totalReceivedMessageLoader: boolean;
  totalSentMessagesAfterRenewed: number;
  totalSentMessageAfterRenewedLoader: boolean;
  totalReceivedMessagesAfterRenewed: number;
  totalReceivedMessageAfterRenewedLoader: boolean;
  receivedNotificationMessageLoader: boolean;
  createdUserCount: number;
  createdUserCountLoader: boolean;
  hsmCountLoader: boolean;
  sentCountLoader: boolean;
  sentCountAfterRenewalLoader: boolean;
  connectionLoader: boolean;
  countArgs = {
    developerId: null,
    applicationId: null,
    connectorId: null,
  };
  editedApplicationName: string;
  editedApplicationURLHandle: string;
  editedApplicationDescription: string;
  todaysCountLoader = true;
  weeklyCountLoader = true;
  monthlyCountLoader = true;
  yearlyCountLoader = true;
  templateLoader = false;
  disableBotIdAndUrlInput = false;
  showClass = false;
  applicationParams: any;
  connectorError: number;
  airbnbconnectorError: number;
  twitchconnectorError: number;
  instagramconnectorError: number;
  twitterconnectorError: number;
  connectorName = "";
  redirectURL;
  airbnbredirectURL;
  twitchredirectURL;
  instagramredirectURL;
  clientID;
  airbnbClientId;
  twitchClientId;
  instagramClientId;
  whatsAppConnFilter: any = [];
  receivedNotificationMsgCount: number;
  audioReceivedTotalDuration:any
  paginationCount: number = 0;
  page: number = 1;
  paginationDisabled: boolean = false;
  templatekeyBackup: any;
  asrr: any;
  apiToken: string = "";
  apiSecret: string = "";
  tokenLoader: boolean = false;
  todate: any;
  fromdate: any;
  downloadReport: boolean;
  reportDownloadBtn: boolean;
  dataSource: any;

  activeUserReport: boolean = false;
  reportloadershow: boolean = false;
  selectedDateRange: any;
  selectedReportDateRange: any;
  customerId: any;
  addCustomerId: any;
  addCustomerIdStatus: boolean = false;
  loaderTrue: boolean = false;
  addConnectorDetails2: any = [];
  search: any;
  addConnectorDetails3: any[];
  connectorSelected: any;
  connectorIdSelected: any;
  delconfirmConnector: string;
  delconfirmBotDetails: string;
  noRecordsFound: boolean = false;
  addCustomerName: string;
  customerName: string;
  updateCustomerNameStatus: boolean;
  addCustomerNameStatus: boolean;
  isDisabled: boolean = false;
  channelQrCode: any = '';
  uploadloader: boolean = false;
  openConnector:any;
  totalTemplatePage: any;
  templateConnectorsBackup: any;
  connectorValue: any = 'manual';
  state:any;
  chooseEmbedded: boolean = false;
  tiktokClientId: any;
  tiktokRedirectURL: any;
    constructor(
    private AmCharts: AmChartsService,
    private applicationService: ApplicationService,
    private toastr: ToastrService,
    public translate: TranslateService,
    private route: ActivatedRoute,
    private renderer: Renderer2,
    private envService: EnvironmentService,
    public fb: FormBuilder,
    private router: Router
  ) {
    this.redirectURL = this.envService.read("redirectURL");
    this.airbnbredirectURL = this.envService.read("airbnbredirectURL");
    this.twitchredirectURL = this.envService.read("twitchredirectURL");
    this.instagramredirectURL = this.envService.read("instagramredirectURL");
    this.clientID = this.envService.read("clientID");
    this.airbnbClientId = this.envService.read("airbnbClientId");
    this.twitchClientId = this.envService.read("twitchClientId");
    this.instagramClientId = this.envService.read("instagramClientId");
    this.tiktokClientId = this.envService.read("tiktokClientId");
    this.tiktokRedirectURL = this.envService.read("tiktokRedirectURL");
    this.route.queryParams.subscribe((params) => {
      console.log("params", params)
      this.applicationParams = params;
      if (this.applicationParams && this.applicationParams.status === true) {
        this.toastr.success("successfully Connected Facebook ");
      }
    });
    if (this.router.getCurrentNavigation()?.extras?.state ?. id) {
      this.state = this.router.getCurrentNavigation().extras.state.id;
      console.log("state", this.state)
    }
  }

  ngOnInit() {
    this.loadershow = true;
    this.selectedDateRange = "last30";
    this.selectedReportDateRange = "today";
    this.reportDownloadBtn = true;
    this.bsRangeValue = [
      new Date(Date.parse(this.fromDate._d)),
      new Date(Date.parse(this.toDate._d)),
    ];
    this.userData = JSON.parse(localStorage.getItem("user"));
    let args = {
      developerId: this.userData.id,
    };
    this.countArgs = {
      developerId: this.userData.id,
      applicationId: null,
      connectorId: null,
    };

    for (let i = 1; i < 11; i++) {
      this.resTranslationCount.push(i);
    }
    this.getLanguageList();
    this.getApplicationList(args);

    var month1 = moment(this.todaysDate)
      .subtract(5, "month")
      .startOf("month")
      .format("YYYY-MM-DD");
    var check = moment(month1, "YYYY/MM/DD");
    this.check11 = check;
    this.monthfromActive = check.format("M");
    this.monthfromActive1 = parseInt(this.monthfromActive);
    this.formattedfromActive = moment(this.monthfromActive, "MM").format(
      "MMMM"
    );
    this.yearfromActive = check.format("YYYY");
    this.yearfromActive3 = parseInt(this.yearfromActive);

    var month3 = moment(this.todaysDate)
      .subtract(12, "month")
      .startOf("month")
      .format("YYYY-MM-DD");
    var check3 = moment(month3, "YYYY/MM/DD");
    this.yearfromActive1 = check3.format("YYYY");

    var month2 = moment(this.todaysDate)
      .subtract(0, "month")
      .startOf("month")
      .format("YYYY-MM-DD");
    var check2 = moment(month2, "YYYY/MM/DD");
    this.check21 = check2;
    this.monthtoActive = check2.format("M");
    this.formattedtoActive = moment(this.monthtoActive, "MM").format("MMMM");
    this.monthtoActive1 = parseInt(this.monthtoActive);
    this.yeartoActive = check2.format("YYYY");
    this.yeartoActive4 = parseInt(this.yeartoActive);
    this.yeartoActive1 = parseInt(this.yearfromActive);
    this.yearfromActive2 = parseInt(this.yearfromActive1);

    this.yearSubtract = this.yeartoActive - 2020;

    for (var i = this.yearSubtract; i >= 0; i--) {
      let min_date = moment().subtract(i, "years").format("YYYY-MM-DD");
      var check5 = moment(min_date, "YYYY/MM/DD");
      this.yeartoActivepreviousmonth = parseInt(check5.format("YYYY"));
      this.yearSelect1.push(this.yeartoActivepreviousmonth);
    }

    if (this.state) {
        this.clickedItem = {id: this.state};
      let params = {
        developerId: this.userData.id,
        applicationId: this.state,
      };
      this.getApplicationDetails(params);
      this.getConnectorDetails(args);
    }
  }

  ngOnDestroy() {
    localStorage.removeItem("appDetails");
  }

  /** EXCEL Download **/

  reportDownload() {
    this.reportloadershow = true;
    this.activeUserReport = true;
    if (this.selectedReportDateRange == "today") {
      this.switchReportDateRange();
    }
    const fileName =
      "Usage_report_" + moment().format("Y-M-D_H-mm-ss") + ".xlsx";
    const args = {
      appId: this.applicationId,
      fromDate: this.fromDate,
      toDate: this.toDate,
    };
    this.applicationService.downloadCountReport(args).subscribe(
      (data) => {
        if (data.info.length > 0) {
          this.dataSource = data.info;
          this.dataSource.forEach(function (x1) {
            x1.Date = moment(x1.Date).format("MM-DD-YYYY");
            return x1;
          });
          const opts = {
            headers: true,
            column: { style: { Font: { Bold: "1" } } },
            rows: { 1: { style: { Font: { Color: "#FF0077" } } } },
            cells: {
              1: {
                1: {
                  style: { Font: { Color: "#00FFFF" } },
                },
              },
            },
          };

          alasql(
            'SELECT Date as [Date (mm-dd-yyyy)], Channel as [Channel], channelID as [Channel ID], customerName as [Customer Name],customerId as [Customer ID],totalNormalSentCount as [Sent Message Count],totalTemplateSentCount as [Sent Template Messages Count],totalSentCount as [Total Sent Messages Count],totalNormalReceivedCount as [Received Messages],totalNotificationReceivedCount as [Received Notification Messages],totalReceivedCount as [Total Received Messages Count],totalSentReceivedCount as [Total Sent and Received Messages (excl. Notifications)],totalSentReceivedCountNotification as [Total Sent and Received Messages (incl. Notifications)] INTO XLSX("' +
              fileName +
              '",?) FROM ?',
            [opts, data.info]
          );
          this.closeModalDialog("downloadReport");
          this.reportloadershow = false;
          this.activeUserReport = false;
          this.selectedReportDateRange == "today";
        } else {
          // this.toastr.error("No data found for selected date range");
          const opts = {
            headers: true,
            column: { style: { Font: { Bold: "1" } } },
            rows: { 1: { style: { Font: { Color: "#FF0077" } } } },
            cells: {
              1: {
                1: {
                  style: { Font: { Color: "#00FFFF" } },
                },
              },
            },
          };
          alasql(
            'SELECT Date as [Date (mm-dd-yyyy)], Channel as [Channel], channelID as [Channel ID], customerName as [Customer Name],customerId as [Customer ID],totalNormalSentCount as [Sent Message Count],totalTemplateSentCount as [Sent Template messages Count],totalSentCount as [Total Sent Messages Count],totalNormalReceivedCount as [Received messages],totalNotificationReceivedCount as [Received Notification Messages],totalReceivedCount as [Total Received Messages Count],totalSentReceivedCount as [Total Sent and Received Messages (excl. Notifications)],totalSentReceivedCountNotification as [Total Sent and Received Messages (incl. Notifications)] INTO XLSX("' +
              fileName +
              '",?) FROM ?',
            [opts, data.info]
          );
          this.activeUserReport = false;
          this.reportloadershow = false;
          this.closeModalDialog("downloadReport");
          this.selectedReportDateRange == "today";
        }
      },
      (error2) => {
        this.reportloadershow = false;
        this.activeUserReport = false;
        this.selectedReportDateRange == "today";
      }
    );
  }

  clickDownloadReport() {
    this.downloadReport = true;
  }

  generateApiToken() {
    this.tokenLoader = true;
    let args = {
      developerId: this.userData.id,
      applicationId: this.applicationContent.applicationId,
      applicationKey: this.applicationContent.accessKey,
      applicationSecret: this.applicationContent.secret,
    };

    this.applicationService.getApiToken(args).subscribe(
      (data) => {
        if (data && data.status == 200) {
          this.apiToken = data.info.ue_auth_key;
          this.apiSecret = data.info.ue_auth_secret;
          this.toastr.success("API token generated successfully");
          this.tokenLoader = false;
        } else {
          this.toastr.success(data.info);
          this.tokenLoader = false;
        }
      },
      (err) => {
        this.tokenLoader = false;
      }
    );
  }

  getCreatedUsersCount(id) {
    this.createdUserCountLoader = true;
    let args = {
      developerId: this.userData.id,
      applicationId: id,
    };

    this.applicationService.getCreatedUsersCount(args).subscribe(
      (data) => {
        if (data && data.status == true) {
          this.createdUserCount = data.info ? data.info : 0;
          this.createdUserCountLoader = false;
        } else {
          this.createdUserCountLoader = false;
        }
      },
      (err) => {
        this.createdUserCountLoader = false;
      }
    );
  }

  getNumberOfConnectionsCount(id) {
    this.connectionLoader = true;
    this.countArgs.applicationId = id;
    console.log("connectorDetails are:",this.connectorDetails);
    if (this.connectorDetails) {
      this.connectorDetails.forEach((element) => {
        this.countArgs.connectorId = element.id;
        this.applicationService
          .getNumberOfConnectionsCount(this.countArgs)
          .subscribe(
            (data) => {
              if (data && data.status === true) {
                element.connectionCount = data.info ? data.info : 0;
                this.connectionLoader = false;
              } else {
                this.connectionLoader = false;
              }
            },
            (err) => {
              this.connectionLoader = false;
            }
          );
      });
    }
  }

  getNumberOfMessagesSentCount(id) {
    this.sentCountLoader = true;
    this.countArgs.applicationId = id;
    if (this.connectorDetails) {
      this.connectorDetails.forEach((element) => {
        this.countArgs.connectorId = element.id;
        this.applicationService
          .getNumberOfMessagesSentCount(this.countArgs)
          .subscribe(
            (data) => {
              if (data && data.status === true) {
                element.sentCount = data.info ? data.info : 0;
                this.sentCountLoader = false;
              } else {
                this.sentCountLoader = false;
              }
            },
            (err) => {
              this.sentCountLoader = false;
            }
          );
      });
    }
  }

  getNumberOfMessagesSentCountAfterRenewal(id, renewalDate) {
    this.sentCountAfterRenewalLoader = true;
    let args = {
      applicationId: id,
      fromDate: renewalDate,
      toDate: moment().format("YYYY-MM-DD"),
      developerId: this.countArgs.developerId,
      connectorId: null,
    };
    if (this.connectorDetails) {
      this.connectorDetails.forEach((element) => {
        args.connectorId = element.id;
        this.applicationService.getNumberOfMessagesSentCount(args).subscribe(
          (data) => {
            if (data && data.status === true) {
              element.sentCountAfterRenewal = data.info ? data.info : 0;
              this.sentCountAfterRenewalLoader = false;
            } else {
              this.sentCountAfterRenewalLoader = false;
            }
          },
          (err) => {
            this.sentCountAfterRenewalLoader = false;
          }
        );
      });
    }
  }

  getHsmMessagesCount(id) {
    console.log("connectorDetails", this.connectorDetails)
    this.hsmCountLoader = true;
    this.countArgs.applicationId = id;
    if (this.connectorDetails) {
      this.connectorDetails.forEach((element) => {
        if (element.hasHsm === true) {
          this.countArgs.connectorId = element.id;
          this.applicationService.getHsmMessagesCount(this.countArgs).subscribe(
            (data) => {
              console.log("data template", data)
              this.totalTempalteLoader = true;
              if (data && data.status === true) {
                this.totalTemplate = data.total ? data.total : 0;
                console.log("this.totalTemplate", this.totalTemplate)
                element.hsmCount = data.info ? data.info : 0;
                this.totalTempalteLoader = false;
                this.hsmCountLoader = false;
              } else {
                this.hsmCountLoader = false;
              }
            },
            (err) => {
              this.hsmCountLoader = false;
            }
          );
        } else {
          this.hsmCountLoader = false;
          element.hsmCount = 0;
        }
      });
    }
  }

  getApplicationList(args) {
    this.applicationService.getApplicationList(args).subscribe((data) => {
      let appSession;
      if (data && data.status == true) {
        this.loadershow = false;
        this.applicationList = data.info;
        this.editedApplicationName = data.info[0].applicationName;
        this.editedApplicationDescription = data.info[0].description;
        if (localStorage.getItem("appDetails") != "undefined") {
          appSession = JSON.parse(localStorage.getItem("appDetails"));
        }
        if (appSession) {
          this.viewApplicationDetails(appSession);
        } else {
          this.viewApplicationDetails(data.info[0]);
        }
      } else {
        this.loadershow = false;
      }
    });
  }

  getLanguageList() {
    this.applicationService.getLanguageList().subscribe((data) => {
      if (data && data.status == true) {
        this.languageTranslate = data.info;
      }
    });
  }

  validURL(str) {
    var pattern = new RegExp("^(http|https):[^s]*?"); // fragment locator
    return !!pattern.test(str);
  }

  validName(str) {
    var pattern = new RegExp("[!@#$%^&*(),.?\":';/\\{}|<>-]");
    return !pattern.test(str);
  }

  checkScroll() {
    const scrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    if (scrollPosition >= this.topPosToStartShowing) {
      this.gotoTop();
    }
  }

  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }

  viewApplicationDetails(item) {
    this.apiToken = "";
    this.apiSecret = "";
    this.isEditApplication = false;
    this.isEditApplicationDescription = false;
    this.loadershow = true;
    this.checkScroll();
    if (item && !this.state) {
      this.clickedItem = item;
      localStorage.setItem("appDetails", JSON.stringify(item));
    }

    let args = {
      developerId: this.userData.id,
      applicationId: item ? item.id : "",
    };
    if (item && !this.state) {
      this.getApplicationDetails(args);
      this.getConnectorDetails(args);
    } else {
      this.loadershow = false;
    }
  }

  getApplicationDetails(args) {
    this.cancelAdd();
    this.cancelNameAdd();
    this.updateCustomerIdStatus = false;
    this.addCustomerIdStatus = false;
    this.updateCustomerNameStatus = false;
    this.addCustomerNameStatus = false;
    this.headerArray = [];
    this.whatsAppConnFilter = [];
    this.applicationService.getApplicationDetails(args).subscribe((data) => {
      this.loadershow = false;
      if (data && data.status == true) {
        console.log("data", data)
        this.connectorDetails = data.info.connetcorDetails;
        this.applicationContent = data.info.applicationDetails;
        this.customerId = this.applicationContent.customerId;
        this.customerName = this.applicationContent.customerName;
        this.isDisabled = this.applicationContent.isDisabled;
        this.applicationId = data.info.applicationDetails.applicationId;
        this.editedApplicationName = this.applicationContent.name;
        this.editedApplicationDescription = this.applicationContent.description;
        this.applId = this.applicationId;
       let value = this.connectorDetails.findIndex((val) =>  val.name === 'WhatsappOfficial')
       this.whatsappConnecterAdded = value === -1 ? false : true;
       let value1 = this.connectorDetails.findIndex((val) =>  val.name === 'WhatsApp Cloud')
       this.whatsappCloudConnecterAdded = value1 === -1 ? false : true
        this.totalSentMsgCount(this.applicationId);
        this.activeUsersMonth(this.applicationId);
        this.totalSentMsgAfterRenewedCount(
          this.applicationId,
          this.applicationContent.lastRenewedAt
        );
        this.audioReceivedCount(this.applicationId)
        this.getCreatedUsersCount(this.applicationId);
        this.totalReceivedMsgCount(this.applicationId);
        this.totalReceivedMsgAfterRenewedCount(
          this.applicationId,
          this.applicationContent.lastRenewedAt
        );
        this.getNumberOfMessagesSentCount(this.applicationId);
        this.getNumberOfMessagesSentCountAfterRenewal(
          this.applicationId,
          this.applicationContent.lastRenewedAt
        );
        this.getNumberOfConnectionsCount(this.applicationId);
        this.getHsmMessagesCount(this.applicationId);
        if (this.applicationContent.translationLanguage) {
          this.enabilecheckbox = false;
        }
        this.callBackPersistCount = this.applicationContent.numberOfCallback
          ? this.applicationContent.numberOfCallback
          : 0;
        this.callbackper = this.applicationContent.callbackPersist;
        if (this.connectorDetails.length > 0) {
          this.showSuccess = false;
          this.whatsAppConnFilter = this.connectorDetails.filter(
            (book: any) => (book.name == "WhatsappOfficial" || book.name == "WhatsAppSandbox" ||  book.name == "WhatsApp Trial" ||  book.name == "WhatsApp Cloud")
          );
          if (this.whatsAppConnFilter && this.whatsAppConnFilter.length > 0) {
            this.receivedNotificationMessageCount(this.applicationId);
          }
          this.totalTempalteLoader = true;
        } else {
          this.showSuccess = true;
        }
        this.countDetails = data.count;
        this.headerLength = this.applicationContent["headers"]
          ? Object.keys(this.applicationContent["headers"]).length
          : 0;
        if (this.applicationContent["headers"]) {
          this.headerArray = Object.entries(
            this.applicationContent["headers"]
          ).map(([key, value]) => ({ key, value }));
        }
        for (let i = this.headerLength; i < 3; i++) {
          this.headerArray.push({ key: "", value: "" });
        }
      } else {
        if (data.info == "email_address_missing") {
          this.translate
            .get("Application.EmailMissing")
            .subscribe((res: string) => {
              this.toastr.error(res);
            });
        } else if (data.info == "no_application") {
          this.translate
            .get("Application.NoApplication")
            .subscribe((res: string) => {
              this.toastr.error(res);
            });
        } else if (data.info == "server_issue") {
          this.translate
            .get("Application.SomethingWrong")
            .subscribe((res: string) => {
              this.toastr.error(res);
            });
        } else {
          this.toastr.error("", data.info);
        }
      }
    });
  }

  Cancel() {
    this.activeMonthlyUsers1 = "";
    this.activeboolean = false;
  }

  processChartDataDetails(chartDetails) {
    let dataProvider = [];
    if (chartDetails) {
      let res2 = [];

      Object.keys(chartDetails).forEach((key) => {
        let obj2 = {};
        obj2["month"] = chartDetails[key].month;
        obj2["value"] = chartDetails[key].count;
        res2.push(obj2);
      });

      let monthArray = _.chain(res2)
        .groupBy("month")
        .map((value, key) => {
          let values = _.pluck(value, "value");
          let count = values.reduce((a, b) => {
            return a + b;
          });
          return {
            month: key,
            value: count,
          };
        })
        .value();
      _.filter(monthArray, (items) => {
        dataProvider.push(items);
      });
    }

    return dataProvider;
  }

  makeCharts() {
    let sentChartData = [];

    if (this.dashboardChartDetails) {
      this.noRecords = false;
      sentChartData = this.processChartDataDetails(this.dashboardChartDetails);
      if (sentChartData) {
        this.sentChartOptions.dataProvider = sentChartData;

        this.chart = this.AmCharts.makeChart(
          "chartdiv",
          this.sentChartOptions,
          1
        );
      } else {
        //Do Nothing
      }
    } else {
      //DO Nothing
    }
  }

  getDashboardChartDetails() {
    this.startclear = false;

    this.monthsexceeded = false;
    this.countzero = false;

    this.fromMonthActive = this.monthForm.value.monthcontrol;
    this.fromYearActive = this.yearForm.value.yearcontrol;
    this.toMonthActive = this.monthForm2.value.monthcontrol2;
    this.toYearActive = this.yearForm2.value.yearcontrol2;

    let argschart = {
      applicationId: this.applId,
      fromYear: this.fromYearActive ? this.fromYearActive : this.yearfromActive,
      toYear: this.toYearActive ? this.toYearActive : this.yeartoActive,
      fromMonth: this.fromMonthActive
        ? this.fromMonthActive
        : this.formattedfromActive,
      toMonth: this.toMonthActive ? this.toMonthActive : this.formattedtoActive,
    };

    var fromm = this.fromMonthActive
      ? this.fromMonthActive
      : this.formattedfromActive;
    this.m11 = moment().month(fromm).format("M");
    var y1 = this.fromYearActive ? this.fromYearActive : this.yearfromActive;

    var tom = this.toMonthActive ? this.toMonthActive : this.formattedtoActive;
    this.m12 = moment().month(tom).format("M");
    var y2 = this.toYearActive ? this.toYearActive : this.yeartoActive;

    this.numberOfMonths = (y2 - y1) * 12 + (this.m12 - this.m11);

    if (this.numberOfMonths > 12) {
      this.monthsexceeded = true;
    } else if (this.numberOfMonths < 0) {
      this.negativechoosen = true;
    } else {
      this.negativechoosen = false;
      this.monthsexceeded = false;
    }

    this.applicationService
      .getDashboardChartDetails(argschart)
      .subscribe((data) => {
        this.loadershow = false;
        this.countactiveusers = 0;
        if (data && data.status == true) {
          this.pageLoader = false;
          this.dashboardChartDetails = data.info;

          this.startclear = false;
          this.noRecords = false;
          this.makeCharts();
          for (let o of this.dashboardChartDetails) {
            this.countactiveusers += o.count;
          }
          this.activeMonthlyUsers1 = this.countactiveusers;

          if (this.countactiveusers == 0) {
            this.countzero = true;
          } else {
            this.countzero = false;
          }
        } else {
          this.pageLoader = false;
        }
      });
  }

  SubmitActiveUser() {
    this.countactiveusers = 0;
    this.getDashboardChartDetails();
  }

  getConnectorDetails(args) {
    console.log("applicationParams", this.applicationParams)
    this.applicationService.getConnectorDetails(args).subscribe((data) => {
      if (data && data.status == true) {
        this.addConnectorDetails = data.info;
        this.addConnectorDetails2 = data.info;
        this.addConnectorDetails3 = data.info;
        if (
          this.applicationParams &&
          this.applicationParams.connector === "fbmessenger"
        ) {
          if (
            this.applicationParams &&
            this.applicationParams.status === "false"
          ) {
            $("#addConnector").modal();
            let connector = _.findWhere(this.addConnectorDetails, {
              id: "0f240135-6d9d-4afc-b382-dc55806118a1",
            });
            this.selectedConnectorDetails = connector;
            this.connectorError = this.applicationParams.error;
            this.selectedIndex = 1;
          } else {
            this.toastr.success("fbmessenger authenticated successfully");
            this.closeFBModel();
          }
        } else if (
          this.applicationParams &&
          this.applicationParams.connector === "airbnb"
        ) {
          if (
            this.applicationParams &&
            this.applicationParams.status === "false"
          ) {
            $("#addConnector").modal();
            let connector = _.findWhere(this.addConnectorDetails, {
              id: "e25368a8-9d5d-4fa9-a7f0-2625a2ab08f3",
            });
            this.selectedConnectorDetails = connector;
            this.airbnbconnectorError = this.applicationParams.error;
            this.selectedIndex = 1;
          } else {
            this.toastr.success("Airbnb authenticated successfully");
            this.closeFBModel();
          }
        } else if (
          this.applicationParams &&
          this.applicationParams.connector === "twitch"
        ) {
          if (
            this.applicationParams &&
            this.applicationParams.status === "false"
          ) {
            $("#addConnector").modal();
            let connector = _.findWhere(this.addConnectorDetails, {
              id: "f46704b6-9c15-465d-a755-324851b08139",
            });
            this.selectedConnectorDetails = connector;
            this.twitchconnectorError = this.applicationParams.error;
            this.selectedIndex = 1;
          } else {
            this.toastr.success("Twitch authenticated successfully");
            this.closeFBModel();
          }
        } else if (
          this.applicationParams &&
          this.applicationParams.connector === "instagram"
        ) {
          if (
            this.applicationParams &&
            this.applicationParams.status === "false"
          ) {
            $("#addConnector").modal();
            let connector = _.findWhere(this.addConnectorDetails, {
              id: "d1cf38b9-d1bb-42d7-98ef-df8d9935b744",
            });
            this.selectedConnectorDetails = connector;
            this.instagramconnectorError = this.applicationParams.error;
            this.selectedIndex = 1;
          } else {
            this.toastr.success("Instagram authenticated successfully");
            this.closeFBModel();
          }
        }else if (
          this.applicationParams &&
          this.applicationParams.connector === "twitter"
        ) {
          if (
            this.applicationParams &&
            this.applicationParams.status === "false"
          ) {
            $("#addConnector").modal();
            let connector = _.findWhere(this.addConnectorDetails, {
              id: "12d93d72-773b-473f-95e1-7e4ac537e1f2",
            });
            this.selectedConnectorDetails = connector;
            this.twitterconnectorError = this.applicationParams.error;
            this.selectedIndex = 1;
          } else {
            this.toastr.success("Twitter authenticated successfully");
            window.location.reload();
            this.closeModel();

          }
        }
      }
    });

  }

  tabChanged(tabChangeEvent) {
    this.selectedIndex = tabChangeEvent.index;
    this.tabName = tabChangeEvent.tab.textLabel;
  }
  fblogin() {
    var clientId = this.clientID;
    let redirectUrl = this.redirectURL;
    let state = this.applicationContent.applicationId;

    window.location.href = `https://www.facebook.com/dialog/oauth?client_id=${clientId}&redirect_uri=${redirectUrl}&scope=public_profile,pages_show_list,read_page_mailboxes,pages_messaging,pages_read_engagement,pages_manage_metadata,pages_read_user_content,pages_manage_ads,pages_manage_engagement,public_profile,manage_pages&state=${state}`;
  }

  airbnblogin() {
    var clientId = this.airbnbClientId;
    let redirectUrl = this.airbnbredirectURL;
    let state = this.applicationContent.applicationId;
    window.location.href = `https://www.airbnb.com/oauth2/auth?client_id=${clientId}&redirect_uri=${redirectUrl}&scope=messages_read,messages_write&state=${state}`;
  }

  twitchlogin() {
    let clientId = this.twitchClientId;
    let redirectUrl = this.twitchredirectURL;
    let state = this.applicationContent.applicationId;
    window.location.href = `https://id.twitch.tv/oauth2/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUrl}&scope=openid chat:read chat:edit&state=${state}`;
  }

  instagramlogin() {
    let clientId = this.instagramClientId;
    let redirectUrl = this.instagramredirectURL;
    let state = this.applicationContent.applicationId;
    window.location.href = `https://www.facebook.com/dialog/oauth?client_id=${clientId}&redirect_uri=${redirectUrl}&scope=public_profile,pages_show_list,pages_messaging,pages_read_engagement,pages_manage_metadata,instagram_basic,instagram_manage_messages,instagram_content_publish,instagram_manage_comments&state=${state}`;
  }
  whatsappCloudlogin() {
    let apiType;
    if(this.connectorName === 'WhatsappOfficial') {
      apiType = "OnPromise"
    } else {
      apiType = "CloudAPI"
    }
    this.closeModalDialog("addConnector");
   let data = { "connectorId": this.connector_id , "apiType": apiType, "appId": this.applicationContent.applicationId}
    this.router.navigate(['/embeddedsignup'], { state: { id: data } });
  }
  async nextStep() {
    let connector = _.findWhere(this.addConnectorDetails, {
      id: this.connectorIdSelected,
    });
    this.selectedConnectorDetails = connector;
    this.connectorName = this.selectedConnectorDetails && this.selectedConnectorDetails.name ? this.selectedConnectorDetails.name : "";
    this.backButtonDisable = false;
    if(this.connectorName === 'WhatsappOfficial' && !this.whatsappConnecterAdded && this.connectorValue === 'manual') {
      this.maxNumberOfTabs = 5;
    }
    if (this.selectedIndex != this.maxNumberOfTabs) {
      this.selectedIndex = this.selectedIndex + 1;
    }
    let index = this.selectedIndex;
    if ((this.selectedIndex == 2 && (this.connectorName !== 'WhatsappOfficial' || this.connectorName === 'WhatsappOfficial' && this.whatsappConnecterAdded)) || (this.selectedIndex == 3 && this.connectorName === 'WhatsappOfficial' && !this.whatsappConnecterAdded)) {
      if (this.appKey == "" || this.appKey == undefined) {
        this.translate
          .get("Application.EnterAppKey")
          .subscribe((res: string) => {
            this.appKeyRequiredError = res;
          });

        this.selectedIndex = index - 1;
      }
      if (this.appSecret == "" || this.appSecret == undefined) {
        this.translate
          .get("Application.EnterSecretKey")
          .subscribe((res: string) => {
            this.appSecretRequiredError = res;
          });
        this.selectedIndex = index - 1;
      }
      if (this.appSecret && this.appKey) {
        this.selectedIndex = index;
      }
    }

    if ((this.selectedIndex == 3 && (this.connectorName !== 'WhatsappOfficial' || this.connectorName === 'WhatsappOfficial' && this.whatsappConnecterAdded)) || (this.selectedIndex == 4 && this.connectorName === 'WhatsappOfficial' && !this.whatsappConnecterAdded)) {
      if (
        this.botDetailsId &&
        (this.registerUrl == "" || this.registerUrl == undefined)
      ) {
        this.translate
          .get("Application.EnterRegURL")
          .subscribe((res: string) => {
            this.registerUrlRequiredError = res;
          });
        this.selectedIndex = index - 1;
      }
      if (this.registerUrl) {
        if (this.botDetailsId == "" || this.botDetailsId == undefined) {
          this.translate
            .get("Application.EnterBotId")
            .subscribe((res: string) => {
              this.botDetailsIdRequiredError = res;
            });
          this.selectedIndex = index - 1;
        }

        if (this.validURL(this.registerUrl) == false) {
          this.translate
            .get("Application.EnterValidRegURL")
            .subscribe((res: string) => {
              this.registerUrlRequiredError = res;
            });
          this.selectedIndex = index;
        }

        if (this.botDetailsId && this.validURL(this.registerUrl)) {
          let args = {
            developerId: this.userData.id,
            applicationId: this.applicationContent["applicationId"],
            connectorId: this.selectedConnectorDetails["id"],
            botDetails: {
              botId: this.botDetailsId,
              registrationUrl: this.registerUrl,
            },
          };

          let data = await this.validateBotDetails(args);
          if (data && data.status == false) {
            if (data.info == "email_address_missing") {
              this.translate
                .get("Application.EmailMissing")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else if (data.info == "no_application") {
              this.translate
                .get("Application.NoApplication")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else if (data.info == "server_issue") {
              this.translate
                .get("Application.SomethingWrong")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else if (data.info == "no_connector") {
              this.translate
                .get("Common.NoConnector")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else if (data.info == "Botid_exist") {
              this.translate
                .get("Application.BotIdExists")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else {
              this.toastr.error("", data.info);
            }
            this.selectedIndex = index - 1;
          } else {
            this.botDetailsIdRequiredError = "";
            this.registerUrlRequiredError = "";
            this.selectedIndex = index;
          }
        }
      }

      if (this.selectedIndex == this.maxNumberOfTabs - 1) {
        this.nextButtonDisable = true;
        this.displayNext = "none";
        this.display = "block";
      }
    }
    if(this.chooseEmbedded) {
           this.backButtonDisable = true;
          this.displayNext = "none";
        }

  }

  onModelChange(event, connector) {
    let arr = event.split(",");
    this.connector_id = connector.id
    console.log(isArray(event));
    console.log(isArray(arr));
    //this.selectedConnector = arr[1];
    this.connectorSelected = arr[0];
    this.connectorIdSelected = arr[1];
    if (this.oldValue != event) {
      this.nextButtonDisable = false;
      this.registerUrl = "";
      this.botDetailsId = "";
      this.appKey = "";
      this.appSecret = "";
      this.appURLHandle = "";
    }
    this.oldValue = event;
    this.nextButtonDisable = false;
    if (this.connectorIdSelected && this.connectorDetails.length > 0) {
      this.connectorDetails.forEach((element) => {
        if (element.id === this.connectorIdSelected) {
          console.log('element is ', element);
          if (element.botDetails !== null || (element.scheme === 'whatsappsandbox' || element.scheme === 'whatsapptrial' || element.scheme === 'whatsappcloudsandbox')){
            this.disableBotIdAndUrlInput = true;
          } else {
            this.disableBotIdAndUrlInput = false;

          }
        }
      });
    }
    if(this.connectorSelected === 'WhatsAppSandbox' || this.connectorSelected === 'WhatsApp Cloud Sandbox') {
      this.disableBotIdAndUrlInput = true;
    }
  }

  previousStep() {
    this.nextButtonDisable = false;
    this.displayNext = "block";
    this.display = "none";
    if (this.selectedIndex != 0) {
      this.selectedIndex = this.selectedIndex - 1;
    }
    if (this.selectedIndex == 0) {
      this.backButtonDisable = true;
    }
  }

  displayTooltip(content) {
    let length = Object.keys(content).length;
    let keys;
    if (length > 1) {
      keys = Object.keys(content).join(",");
    } else {
      keys = Object.keys(content);
    }
    this.tooltipContent = keys;
  }

  copyKey(val: string) {
    let selBox = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
  }

  updateBotDetails(bot, connection, index1, index2) {
    if (bot.value == "" || bot.value == undefined) {
            this.translate.get("Application.EnterRegURL").subscribe((res: string) => {
              this.urlRequiredError = res;
         });
     }
     if (bot.key && bot.value) {
       this.botIdRequiredError = "";
      this.urlRequiredError = "";

    let args = {
      developerId: this.userData.id,
      applicationId: this.applicationContent["applicationId"],
      connectorId: connection.id,
      botDetails: {
        botId: bot.key,
        registrationUrl: bot.value,
      },
    };
    this.applicationService.updateBotDetails(args).subscribe((data) => {
      if (data && data.status == false) {
        if (data.info == "email_address_missing") {
          this.translate
            .get("Application.EmailMissing")
            .subscribe((res: string) => {
              this.toastr.error(res);
            });
        } else if (data.info == "no_application") {
          this.translate
            .get("Application.NoApplication")
            .subscribe((res: string) => {
              this.toastr.error(res);
            });
        } else if (data.info == "server_issue") {
          this.translate
            .get("Application.SomethingWrong")
            .subscribe((res: string) => {
              this.toastr.error(res);
            });
        } else if (data.info == "no_connector") {
          this.translate.get("Common.NoConnector").subscribe((res: string) => {
            this.toastr.error(res);
          });
        } else {
          this.toastr.error("", data.info);
        }
      } else {
        this.closeModalDialog("updateBotDetails" + index1 + index2);
      }
    });
  }
  }

  async validateBotDetails(args) {
    let data = this.applicationService.validateBotDetails(args).toPromise();
    return data;
  }

  deleteConnector(connectorId) {
    this.translate
      .get("Application.ConfirmDeleteConnector")
      .subscribe((res: string) => {
        this.delconfirm = res;
      });
    if (confirm(this.delconfirm)) {
      let args = {
        developerId: this.userData.id,
        applicationId: this.applicationContent["applicationId"],
        connectorId: connectorId,
      };
      this.applicationService.deleteConnector(args).subscribe((data) => {
        if (data && data.status == false) {
          if (data.info == "email_address_missing") {
            this.translate
              .get("Application.EmailMissing")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else if (data.info == "no_application") {
            this.translate
              .get("Application.NoApplication")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else if (data.info == "server_issue") {
            this.translate
              .get("Application.SomethingWrong")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else if (data.info == "no_connector") {
            this.translate
              .get("Common.NoConnector")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else if (data.info == "no_connector_in_app") {
            this.translate
              .get("Application.NoConnector")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else if (data.info == "connection_exist") {
            this.translate
              .get("Application.CannotDelete")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else {
            this.toastr.error("", data.info);
          }
        } else {
          this.getApplicationDetails(args);
        }
      });
    }
  }

  deleteBotDetails(bot, connection) {
    this.translate
      .get("Application.ConfirmDeleteBotDetails")
      .subscribe((res: string) => {
        this.delconfirmBotDetails = res;
      });
    if (confirm(this.delconfirmBotDetails)) {
      let args = {
        developerId: this.userData.id,
        applicationId: this.applicationContent["applicationId"],
        connectorId: connection.id,
        botDetails: {
          botId: bot.key,
          registrationUrl: bot.value,
        },
      };
      this.applicationService.deleteBotDetails(args).subscribe((data) => {
        if (data && data.status == false) {
          if (data.info == "email_address_missing") {
            this.translate
              .get("Application.EmailMissing")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else if (data.info == "no_application") {
            this.translate
              .get("Application.NoApplication")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else if (data.info == "server_issue") {
            this.translate
              .get("Application.SomethingWrong")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else if (data.info == "no_connector") {
            this.translate
              .get("Common.NoConnector")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else {
            this.toastr.error("", data.info);
          }
        } else {
          this.getApplicationDetails(args);
        }
      });
      this.gotoTop();
    }
  }

  addBotDetails(connection, index) {
    let botDetails = {};
    if (this.botId == "" || this.botId == undefined) {
      this.translate.get("Application.EnterBotId").subscribe((res: string) => {
        this.botIdRequiredError = res;
      });
    }
    if (this.registrationUrl == "" || this.registrationUrl == undefined) {
      this.translate.get("Application.EnterRegURL").subscribe((res: string) => {
        this.urlRequiredError = res;
      });
    }

    if (this.botId && this.registrationUrl) {
      this.botIdRequiredError = "";
      this.urlRequiredError = "";
      if (this.validURL(this.registrationUrl) == false) {
        this.translate
          .get("Application.EnterValidRegURL")
          .subscribe((res: string) => {
            this.urlRequiredError = res;
          });
      } else {
        botDetails["botId"] = this.botId;
        botDetails["registrationUrl"] = this.registrationUrl;
        let args = {
          developerId: this.userData.id,
          applicationId: this.applicationContent["applicationId"],
          connectorId: connection.id,
          botDetails: botDetails,
        };
        this.applicationService.addBotDetails(args).subscribe((data) => {
          if (data && data.status == false) {
            if (data.info == "email_address_missing") {
              this.translate
                .get("Application.EmailMissing")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else if (data.info == "no_application") {
              this.translate
                .get("Application.NoApplication")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else if (data.info == "server_issue") {
              this.translate
                .get("Application.SomethingWrong")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else if (data.info == "no_connector") {
              this.translate
                .get("Common.NoConnector")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else if (data.info == "Botid_exist") {
              this.translate
                .get("Application.BotIdExists")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else {
              this.toastr.error("", data.info);
            }
          } else {
            this.gotoTop();
            this.closeModalDialog("addBotDetails" + index);
            this.botId = "";
            this.registrationUrl = "";
            let params = {
              developerId: this.userData.id,
              applicationId: this.applicationContent["applicationId"],
            };
            this.getApplicationDetails(params);
          }
        });
      }
    }
  }

  clearBotDetails() {
    this.botId = "";
    this.registrationUrl = "";
    this.urlRequiredError = "";
    this.botIdRequiredError = "";
  }

  addApplication() {
    this.connecter = false;
    if (this.applicationName == "" || this.applicationName == undefined) {
      this.translate
        .get("Application.EnterAppName")
        .subscribe((res: string) => {
          this.appNameRequiredError = res;
        });
    } else if (this.validName(this.applicationName) == false) {
      this.translate
        .get("Application.EnterValidAppName")
        .subscribe((res: string) => {
          this.appNameRequiredError = res;
        });
    } else {
      this.appNameRequiredError = "";
      let args = {
        developerId: this.userData.id,
        name: this.applicationName,
        description: this.applicationDescription,
      };
      this.applicationService.addApplication(args).subscribe((data) => {
        if (data && data.status == false) {
          if (data.info == "email_address_missing") {
            this.translate
              .get("Application.EmailMissing")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else if (data.info == "spam_appname") {
            this.translate
              .get("Application.AppNameSpam")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else if (data.info == "Appname_exists") {
            this.translate
              .get("Application.AppNameExists")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else if (data.info == "server_issue") {
            this.translate
              .get("Application.SomethingWrong")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else {
            this.toastr.error("", data.info);
          }
        } else {
          this.closeModalDialog("addApplicationModal");
          localStorage.removeItem("appDetails");
          let items = {
            id: data.info.applicationId,
            name: this.applicationName,
            description: this.applicationDescription,
          };
          localStorage.setItem("appDetails", JSON.stringify(items));
          this.applicationName = "";
          this.applicationDescription = "";
          this.getApplicationList(args);
        }
      });
    }
  }

  closeModelHeader() {
    this.appNameRequiredError = "";
    this.applicationName = "";
    this.applicationDescription = "";
  }

  addConnector(connector) {
    let args = {
      developerId: this.userData.id,
      accessKey: this.appKey,
      urlHandle: this.appURLHandle,
      secret: this.appSecret,
      connectorId: this.connectorIdSelected,
      applicationId: this.applicationContent["applicationId"],
      pollCapablity: connector.pollCapablity,
      endPoint: connector.endPoint,
    };
    args["botDetails"] = {};
    if (connector.hasOptionalParams) {
      Object.entries(connector.optionalParams).forEach(([key], index) => {
        connector.optionalParams[key] =
          this.optionalParamsValue.value[index] &&
          this.optionalParamsValue.value[index][0].name
            ? this.optionalParamsValue.value[index][0].name
            : this.optionalParamsValue.value[index];
      });
      args["optionalParams"] = connector.optionalParams;
    }

    if (this.botDetailsId) {
      args["botDetails"]["botId"] = this.botDetailsId;
    }
    if (this.registerUrl) {
      args["botDetails"]["registrationUrl"] = this.registerUrl;
    }
    this.applicationService.addConnector(args).subscribe((data) => {
      if (data && data.status == false) {
        if (data.info == "email_address_missing") {
          this.translate
            .get("Application.EmailMissing")
            .subscribe((res: string) => {
              this.toastr.error(res);
            });
        } else if (data.info == "no_application") {
          this.translate
            .get("Application.NoApplication")
            .subscribe((res: string) => {
              this.toastr.error(res);
            });
        } else if (data.info == "server_issue") {
          this.translate
            .get("Application.SomethingWrong")
            .subscribe((res: string) => {
              this.toastr.error(res);
            });
        } else if (data.info == "no_connector") {
          this.translate.get("Common.NoConnector").subscribe((res: string) => {
            this.toastr.error(res);
          });
        } else {
          this.toastr.error("", data.info);
        }
      } else {
        this.closeModalDialog("addConnector");
        this.closeModel();
        let params = {
          developerId: this.userData.id,
          applicationId: this.applicationContent["applicationId"],
        };
        this.getApplicationDetails(params);
        this.disableBotIdAndUrlInput = false;
      }
    });
  }

  closeModalDialog(id) {
    $("#" + id).modal("hide");
  }

  showModalDialog(id) {
    $("#" + id).modal("show");
  }

  addWebhookDetails() {
    let headerDetails = {};
    this.headerArray.forEach(function (element, index) {
      if (element.key) {
        headerDetails[element.key] = element.value;
      }
    });
    if (
      this.applicationContent["webhookUrl"] &&
      this.validURL(this.applicationContent["webhookUrl"]) == false
    ) {
      this.translate
        .get("Application.EnterValidURL")
        .subscribe((res: string) => {
          this.webhookValidateError = res;
        });
    } else {
      let args = {
        developerId: this.userData.id,
        applicationId: this.applicationContent["applicationId"],
        webhookUrl: this.applicationContent["webhookUrl"],
        headerDetails,
      };
      this.applicationService.addWebhookDetails(args).subscribe((data) => {
        if (data && data.status == false) {
          if (data.info == "email_address_missing") {
            this.translate
              .get("Application.EmailMissing")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else if (data.info == "no_application") {
            this.translate
              .get("Application.NoApplication")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else if (data.info == "server_issue") {
            this.translate
              .get("Application.SomethingWrong")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else {
            this.toastr.error("", data.info);
          }
        } else {
          this.closeModalDialog("addWebhookDetails");
          this.webhookValidateError = "";
          this.getApplicationDetails(args);
        }
      });
    }
  }

  deleteApplication() {
    this.translate
      .get("Application.ConfirmDeleteApplication")
      .subscribe((res: string) => {
        this.delconfirmapp = res;
      });
    if (confirm(this.delconfirmapp)) {
      let args = {
        developerId: this.userData.id,
        applicationId: this.applicationContent["applicationId"],
      };
      this.applicationService.deleteApplication(args).subscribe((data) => {
        if (data && data.status == false) {
          if (data.info == "email_address_missing") {
            this.translate
              .get("Application.EmailMissing")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else if (data.info == "no_application") {
            this.translate
              .get("Application.NoApplication")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else if (data.info == "server_issue") {
            this.translate
              .get("Application.SomethingWrong")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else if (data.info == "cant_delete_app") {
            this.translate
              .get("Application.CantDelete")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else {
            this.toastr.error("", data.info);
          }
        } else {
          localStorage.removeItem("appDetails");
          let params = {
            developerId: this.userData.id,
          };
          this.applicationContent = "";
          this.editedApplicationName = "";
          this.editedApplicationDescription = "";
          this.getApplicationList(params);
        }
      });
    }
  }

  /** Edit Application Name Section Starts**/
  editApplication() {
    this.isEditApplication = true;
  }

  cancelAppilcationNameEdit() {
    this.isEditApplication = false;
    this.editedApplicationName = this.applicationContent.name;
  }

  retainOriginalApplicationName(event: any) {
    if (this.isEditApplication) {
      this.isEditApplication = false;
      if (this.editedApplicationName === "") {
        this.editedApplicationName = this.applicationContent.name;
      }
    }
  }

  updateApplicationName() {
    this.updateApplicationLoader = true;
    if (this.applicationContent.name === this.editedApplicationName) {
      this.retainOriginalApplicationName(null);
      this.updateApplicationLoader = false;
      return;
    }

    if (this.editedApplicationName === "") {
      this.retainOriginalApplicationName(null);
      this.updateApplicationLoader = false;
      this.toastr.error("Application Name cannot be empty");
      return;
    }

    let args = {
      developerId: this.userData.id,
      applicationId: this.applicationContent["applicationId"],
      name: this.editedApplicationName,
    };

    this.applicationService.updateApplicationName(args).subscribe((data) => {
      if (data && data.status == false) {
        if (data.info == "email_address_missing") {
          this.translate
            .get("Application.EmailMissing")
            .subscribe((res: string) => {
              this.updateApplicationLoader = false;
              this.toastr.error(res);
            });
        } else if (data.info == "Appname_exists") {
          this.updateApplicationLoader = false;
          this.translate
            .get("Application.AppNameExists")
            .subscribe((res: string) => {
              this.toastr.error(res);
            });
        } else if (data.info == "server_issue") {
          this.updateApplicationLoader = false;
          this.translate
            .get("Application.SomethingWrong")
            .subscribe((res: string) => {
              this.toastr.error(res);
            });
        } else if (data.info == "no_application") {
          this.updateApplicationLoader = false;
          this.translate
            .get("Application.NoApplication")
            .subscribe((res: string) => {
              this.toastr.error(res);
            });
        } else if (data.info == "spam_appname") {
          this.updateApplicationLoader = false;
          this.translate
            .get("Application.AppNameSpam")
            .subscribe((res: string) => {
              this.toastr.error(res);
            });
        } else {
          this.updateApplicationLoader = false;
          this.toastr.error("", data.info);
        }
      } else {
        this.translate
          .get("Application.AppUpdateSuccess1")
          .subscribe((res: string) => {
            this.toastr.success(res);
          });
        this.applicationContent = "";
        this.editedApplicationName = "";
        this.isEditApplication = false;
        let applicationArgs = {
          developerId: this.userData.id,
        };
        this.loadershow = false;
        this.getApplicationList(applicationArgs);
        this.updateApplicationLoader = false;
      }
    });
  }
  /** Edit Application Name Section Ends**/

  /** Edit Application Description Section Starts**/
  editApplicationDescription() {
    this.isEditApplicationDescription = true;
  }

  cancelAppilcationDescriptionEdit() {
    this.isEditApplicationDescription = false;
    this.editedApplicationDescription = this.applicationContent.description;
  }

  retainOriginalApplicationDescription(event: any) {
    if (this.isEditApplicationDescription) {
      this.isEditApplicationDescription = false;
      if (this.editedApplicationDescription === "") {
        this.editedApplicationDescription = this.applicationContent.description;
      }
    }
  }

  updateApplicationDescription() {
    if (
      this.applicationContent.description === this.editedApplicationDescription
    ) {
      this.retainOriginalApplicationDescription(null);
      return;
    }

    let args = {
      developerId: this.userData.id,
      applicationId: this.applicationContent["applicationId"],
      description: this.editedApplicationDescription,
    };

    this.applicationService
      .updateApplicationDescription(args)
      .subscribe((data) => {
        if (data && data.status == false) {
          if (data.info == "email_address_missing") {
            this.translate
              .get("Application.EmailMissing")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else if (data.info == "Appname_exists") {
            this.translate
              .get("Application.AppNameExists")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else if (data.info == "server_issue") {
            this.translate
              .get("Application.SomethingWrong")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else if (data.info == "no_application") {
            this.translate
              .get("Application.NoApplication")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else if (data.info == "spam_appname") {
            this.translate
              .get("Application.AppNameSpam")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else {
            this.toastr.error("", data.info);
          }
        } else {
          this.translate
            .get("Application.AppUpdateSuccess2")
            .subscribe((res: string) => {
              this.toastr.success(res);
            });
          this.applicationContent = "";
          this.editedApplicationDescription = "";
          this.isEditApplicationDescription = false;
          let applicationArgs = {
            developerId: this.userData.id,
          };
          this.loadershow = false;
          this.getApplicationList(applicationArgs);
        }
      });
  }
  /** Edit Application Description Section Ends**/

  /** Edit Application URL Handle Section Starts**/
  editApplicationURLHandle(connection) {
    this.isEditApplicationURLHandle = true;
    this.editedApplicationURLHandle = connection.urlHandle
      ? connection.urlHandle
      : "";
  }
  closeConnector(connection , i){
    this.connectorDetails.map(item => {
      item["hideBox"] = false;
     if (item.name === connection.name) {
      item["hideBox"] = true;
     }
    })
    this.openConnector = connection;
    this.cancelApplicationURLHandleEdit();
  }
  cancelApplicationURLHandleEdit() {
    this.isEditApplicationURLHandle = false;
    this.editedApplicationURLHandle = "";
  }

  updateApplicationURLHandle(connection) {
    this.updateApplicationURLHandleLoader = true;
    if(connection.urlHandle == null && this.editedApplicationURLHandle == ""){
      this.updateApplicationURLHandleLoader = false;
      this.cancelApplicationURLHandleEdit();
      return;
    }

    if (connection.urlHandle === this.editedApplicationURLHandle) {
      this.updateApplicationURLHandleLoader = false;
      this.cancelApplicationURLHandleEdit();
      return;
    }
    let args = {
      developerId: this.userData.id,
      accessKey: connection.applicationOriginalKey,
      secret: connection.applicationSecret,
      connectorId: connection.id,
      applicationId: this.applicationContent["applicationId"],
      optionalParams: connection.optionalOriginalParams,
      botDetails: connection.botDetails,
      urlHandle: this.editedApplicationURLHandle,
      connectorScheme: connection.scheme,
      channelQrCode: connection.channelQrCode,
    };
    this.applicationService.updateApplicationURLHandle(args).subscribe((data) => {
      if (data && data.status == false) {
        if (data.info == "email_address_missing") {
          this.translate
            .get("Application.EmailMissing")
            .subscribe((res: string) => {
              this.updateApplicationURLHandleLoader = false;
              this.toastr.error(res);
            });
        } else if (data.info == "Appname_exists") {
          this.updateApplicationURLHandleLoader = false;
          this.translate
            .get("Application.AppNameExists")
            .subscribe((res: string) => {
              this.toastr.error(res);
            });
        } else if (data.info == "server_issue") {
          this.updateApplicationURLHandleLoader = false;
          this.translate
            .get("Application.SomethingWrong")
            .subscribe((res: string) => {
              this.toastr.error(res);
            });
        } else if (data.info == "no_application") {
          this.updateApplicationURLHandleLoader = false;
          this.translate
            .get("Application.NoApplication")
            .subscribe((res: string) => {
              this.toastr.error(res);
            });
        } else if (data.info == "spam_appname") {
          this.updateApplicationURLHandleLoader = false;
          this.translate
            .get("Application.AppNameSpam")
            .subscribe((res: string) => {
              this.toastr.error(res);
            });
        } else {
          this.updateApplicationURLHandleLoader = false;
          this.toastr.error("", data.info);
        }
      } else {
        this.translate
          .get("Application.AppUpdateSuccess1")
          .subscribe((res: string) => {
            this.toastr.success(res);
          });
        this.editedApplicationURLHandle = "";
        this.isEditApplicationURLHandle = false;
        let applicationArgs = {
          developerId: this.userData.id,
        };
        this.loadershow = false;
        this.getApplicationList(applicationArgs);
        this.updateApplicationURLHandleLoader = false;
      }
    });
  }
  /** Edit Application URL Handle Section Ends**/

  countDetailsShow(id, connectorId) {
    this.selectedDateRange = "last30";
    this.toDate = moment();
    this.fromDate = moment().subtract(30, "days");
    this.bsRangeValue = [
      new Date(Date.parse(this.fromDate._d)),
      new Date(Date.parse(this.toDate._d)),
    ];
    this.dateRangeDiv = false;
    this.dateRangeCount = "";
    let args = {
      developerId: this.userData.id,
      applicationId: this.applicationContent["applicationId"],
    };
    if (connectorId) {
      args["connectorId"] = connectorId;
      this.currentOpenConnectorId = connectorId;
    }
    if (id === "user") {
      this.audioDurationLoad=false;
      this.messageSentClick = false;
      this.messageReceivedClick = false;
      this.connectorMsgSentClick = false;
      this.connectorHsmMsgSentClick = false;
      this.receivedNotificationClick = false;
      this.tempalteCoClick = false;
      this.audiototextClick=false;
      this.applicationService.getUserCount(args).subscribe((data) => {
        if (data && data.status == false) {
          if (data.info == "email_address_missing") {
            this.translate
              .get("Application.EmailMissing")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else if (data.info == "no_application") {
            this.translate
              .get("Application.NoApplication")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else if (data.info == "server_issue") {
            this.translate
              .get("Application.SomethingWrong")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else {
            this.toastr.error("", data.info);
          }
        } else {
          this.userCountClick = true;
          this.todaysCountLoader = false;
          this.weeklyCountLoader = false;
          this.monthlyCountLoader = false;
          this.yearlyCountLoader = false;
          this.totalCountDetails = {
            todaysCount: data.info.todaysCount,
            weeklyCount: data.info.weeklyCount,
            monthlyCount: data.info.monthlyCount,
            yearlyCount: data.info.yearlyCount,
            totalCount: data.info.totalCount,
            heading: "Users Count",
            subHeading: "Registered users",
            detailsHeading1: "Today's users",
            detailsHeading2: "Current week users",
            detailsHeading3: "Current month users",
            detailsHeading4: "Current year users",
          };

          this.showModalDialog("countDetails");
        }
      });
    } else if (id === "msgSent") {
      this.audioDurationLoad=false;
      this.userCountClick = false;
      this.messageReceivedClick = false;
      this.connectorMsgSentClick = false;
      this.connectorHsmMsgSentClick = false;
      this.receivedNotificationClick = false;
      this.tempalteCoClick = false;
      this.audiototextClick=false;
      this.messageSentClick = true;
      this.todaysCountLoader = true;
      this.weeklyCountLoader = true;
      this.monthlyCountLoader = true;
      this.yearlyCountLoader = true;
      this.templateLoader = false;

      this.totalCountDetails = {
        todaysCount: 0,
        weeklyCount: 0,
        monthlyCount: 0,
        yearlyCount: 0,
        totalCount: 0,
        heading: "Messages count",
        subHeading: "Messages sent by application",
        detailsHeading1: "Today's messages",
        detailsHeading2: "Current week messages",
        detailsHeading3: "Current month messages",
        detailsHeading4: "Current year messages",
      };

      this.sentTodaysCount();
      this.sentWeeklyCount();
      this.sentMonthlyCount();
      this.sentYearlyCount();
      this.showModalDialog("countDetails");
    } else if (id == "msgReceived") {
      this.audioDurationLoad=false;
      this.userCountClick = false;
      this.messageSentClick = false;
      this.connectorMsgSentClick = false;
      this.connectorHsmMsgSentClick = false;
      this.messageReceivedClick = true;
      this.receivedNotificationClick = false;
      this.tempalteCoClick = false;
      this.audiototextClick=false;
      this.todaysCountLoader = true;
      this.weeklyCountLoader = true;
      this.monthlyCountLoader = true;
      this.yearlyCountLoader = true;
      this.templateLoader = false;

      this.totalCountDetails = {
        todaysCount: 0,
        weeklyCount: 0,
        monthlyCount: 0,
        yearlyCount: 0,
        totalCount: 0,
        heading: "Received messages count",
        subHeading: "Messages received by application",
        detailsHeading1: "Today's received messages",
        detailsHeading2: "Current week received messages",
        detailsHeading3: "Current month received messages",
        detailsHeading4: "Current year received messages",
      };

      this.receivedTodaysCount();
      this.receivedWeeklyCount();
      this.receivedMonthlyCount();
      this.receivedYearlyCount();
      this.showModalDialog("countDetails");
    } else if (id == "connectorMsgSent") {
      this.audioDurationLoad=false;
      this.userCountClick = false;
      this.messageSentClick = false;
      this.messageReceivedClick = false;
      this.connectorHsmMsgSentClick = false;
      this.receivedNotificationClick = false;
      this.tempalteCoClick = false;
      this.audiototextClick=false;
      this.applicationService
        .getConnectorMessageSentCount(args)
        .subscribe((data) => {
          if (data && data.status == false) {
            if (data.info == "email_address_missing") {
              this.translate
                .get("Application.EmailMissing")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else if (data.info == "no_application") {
              this.translate
                .get("Application.NoApplication")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else if (data.info == "server_issue") {
              this.translate
                .get("Application.SomethingWrong")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else if (data.info == "no_connector") {
              this.translate
                .get("Common.NoConnector")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else if (data.info == "no_connector_in_app") {
              this.translate
                .get("Application.NoConnector")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else {
              this.toastr.error("", data.info);
            }
          } else {
            this.connectorMsgSentClick = true;
            this.todaysCountLoader = false;
            this.weeklyCountLoader = false;
            this.monthlyCountLoader = false;
            this.yearlyCountLoader = false;
            this.templateLoader = false;
            this.receivedNotificationClick = false;
            this.tempalteCoClick = false;
            this.audiototextClick=false;
            this.totalCountDetails = {
              todaysCount: data.info.todaysCount,
              weeklyCount: data.info.weeklyCount,
              monthlyCount: data.info.monthlyCount,
              yearlyCount: data.info.yearlyCount,
              totalCount: data.info.totalCount,
              heading: "Messages count",
              subHeading: "Messages sent by application",
              detailsHeading1: "Today's messages",
              detailsHeading2: "Current week messages",
              detailsHeading3: "Current month messages",
              detailsHeading4: "Current year messages",
            };
            this.showModalDialog("countDetails");
          }
        });
    } else if (id == "templateCo") {
      this.audioDurationLoad=false;
      this.userCountClick = false;
      this.messageSentClick = false;
      this.connectorMsgSentClick = false;
      this.connectorHsmMsgSentClick = false;
      this.messageReceivedClick = false;
      this.receivedNotificationClick = false;
      this.tempalteCoClick = true;
      this.audiototextClick=false;
      this.todaysCountLoader = false;
      this.weeklyCountLoader = false;
      this.monthlyCountLoader = false;
      this.yearlyCountLoader = false;
      this.templateLoader = true;
      this.totalTemplatecount(this.applicationId);
      this.totalCountDetails = {
        totalCount: 0,
        heading: "Template Count",
        subHeading: "",
      };
      this.showModalDialog("templateCount");
    } else if (id == "receivedNotification") {
      this.audioDurationLoad=false;
      this.userCountClick = false;
      this.messageSentClick = false;
      this.connectorMsgSentClick = false;
      this.connectorHsmMsgSentClick = false;
      this.messageReceivedClick = false;
      this.receivedNotificationClick = true;
      this.tempalteCoClick = false;
      this.audiototextClick=false;
      this.todaysCountLoader = true;
      this.weeklyCountLoader = true;
      this.monthlyCountLoader = true;
      this.yearlyCountLoader = true;

      this.totalCountDetails = {
        todaysCount: 0,
        weeklyCount: 0,
        monthlyCount: 0,
        yearlyCount: 0,
        totalCount: 0,
        heading: "Received notification message",
        subHeading: "Notification messages by application",
        detailsHeading1: "Today's notification messages",
        detailsHeading2: "Current week notification messages",
        detailsHeading3: "Current month notification messages",
        detailsHeading4: "Current year notification messages",
      };

      this.receivedTodaysNotificationCount();
      this.receivedWeeklyNotificationCount();
      this.receivedMonthlyNotificationCount();
      this.receivedYearlyNotificationCount();
      this.showModalDialog("countDetails");
    } else if (id == "activeUser") {
      this.audioDurationLoad=false;
      this.totalCountDetails = {
        todaysCount: 0,
        weeklyCount: 0,
        monthlyCount: 0,
        yearlyCount: 0,
        totalCount: 0,
        heading: "Monthly active users",

        detailsHeading1: "From Month",
        detailsHeading2: "From Year",
        detailsHeading6: "To Month",
        detailsHeading7: "To Year",
        detailsHeading3: "Current month notification messages",
        detailsHeading4: "Current year notification messages",
      };
      var month1 = moment(this.todaysDate)
        .subtract(5, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      var check = moment(month1, "YYYY/MM/DD");
      this.check11 = check;
      this.monthfromActive = check.format("M");
      this.monthfromActive1 = parseInt(this.monthfromActive);
      this.formattedfromActive = moment(this.monthfromActive, "MM").format(
        "MMMM"
      );
      this.yearfromActive = check.format("YYYY");
      this.yearfromActive3 = parseInt(this.yearfromActive);

      var month3 = moment(this.todaysDate)
        .subtract(12, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      var check3 = moment(month3, "YYYY/MM/DD");
      this.yearfromActive1 = check3.format("YYYY");

      var month2 = moment(this.todaysDate)
        .subtract(0, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      var check2 = moment(month2, "YYYY/MM/DD");
      this.check21 = check2;
      this.monthtoActive = check2.format("M");
      this.formattedtoActive = moment(this.monthtoActive, "MM").format("MMMM");
      this.monthtoActive1 = parseInt(this.monthtoActive);

      this.yeartoActive = check2.format("YYYY");
      this.yeartoActive4 = parseInt(this.yeartoActive);
      this.yeartoActive1 = parseInt(this.yearfromActive);
      this.yearfromActive2 = parseInt(this.yearfromActive1);

      this.startclear = true;
      this.monthForm2.patchValue({ monthcontrol2: this.formattedtoActive });
      this.monthForm.patchValue({ monthcontrol: this.formattedfromActive });
      this.yearForm.patchValue({ yearcontrol: this.yearfromActive3 });
      this.yearForm2.patchValue({ yearcontrol2: this.yeartoActive4 });
      this.getDashboardChartDetails();

      this.showModalDialog("activeUser");

    } else if(id == "audioDuration"){
      this.audioDurationLoad=true
      this.userCountClick = false;
      this.messageSentClick = false;
      this.connectorMsgSentClick = false;
      this.connectorHsmMsgSentClick = false;
      this.messageReceivedClick = false;
      this.receivedNotificationClick = false;
      this.audiototextClick= true;
      this.tempalteCoClick = false;
      this.userCountClick = false;
      this.todaysCountLoader = false;
      this.weeklyCountLoader = false;
      this.monthlyCountLoader = false;
      this.yearlyCountLoader = false;
      this.totalCountDetails = {
        todaysCount: 0,
        weeklyCount: 0,
        monthlyCount: 0,
        yearlyCount: 0,
        totalCount: 0,
        heading: "Audio message duration",
        subHeading: "Audio messages by application",
        detailsHeading1: "Today's audio message duration",
        detailsHeading2: "Current week audio message duration",
        detailsHeading3: "Current month audio message duration",
        detailsHeading4: "Current year audio message duration",
      };
      this.audioTodaysCount();
      this.audioReceivedWeeklyCount();
      this.audioReceivedMonthlyCount();
      this.audioReceivedYearlyCount();
      this.showModalDialog("countDetails");
    } else {
      this.audioDurationLoad=false;
      this.userCountClick = false;
      this.messageSentClick = false;
      this.messageReceivedClick = false;
      this.connectorMsgSentClick = false;
      this.receivedNotificationClick = false;
      this.tempalteCoClick = false;
      this.audiototextClick=false;
      this.applicationService
        .getConnectorHsmSentCount(args)
        .subscribe((data) => {
          if (data && data.status == false) {
            if (data.info == "email_address_missing") {
              this.translate
                .get("Application.EmailMissing")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else if (data.info == "no_application") {
              this.translate
                .get("Application.NoApplication")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else if (data.info == "server_issue") {
              this.translate
                .get("Application.SomethingWrong")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else if (data.info == "no_connector") {
              this.translate
                .get("Common.NoConnector")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else if (data.info == "no_connector_in_app") {
              this.translate
                .get("Application.NoConnector")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else {
              this.toastr.error("", data.info);
            }
          } else {
            this.connectorHsmMsgSentClick = true;
            this.todaysCountLoader = false;
            this.weeklyCountLoader = false;
            this.monthlyCountLoader = false;
            this.yearlyCountLoader = false;
            this.totalCountDetails = {
              todaysCount: data.info.todaysCount,
              weeklyCount: data.info.weeklyCount,
              monthlyCount: data.info.monthlyCount,
              yearlyCount: data.info.yearlyCount,
              totalCount: data.info.totalCount,
              heading: "Template messages count",
              subHeading: "Template messages sent by application",
              detailsHeading1: "Today's messages",
              detailsHeading2: "Current week messages",
              detailsHeading3: "Current month messages",
              detailsHeading4: "Current year messages",
            };
            this.showModalDialog("countDetails");
          }
        });
    }
  }

  sentTodaysCount() {
    let args = {
      developerId: this.userData.id,
      applicationId: this.applicationContent["applicationId"],
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    };
    this.applicationService.totalSentMsgCount(args).subscribe(
      async (data) => {
        if (data && data.status == true) {
          this.totalCountDetails.todaysCount = data.info.totalCount;
          this.todaysCountLoader = false;
        } else {
          this.totalCountDetails.todaysCount = 0;
          this.todaysCountLoader = false;
        }
      },
      (err) => {
        this.totalCountDetails.todaysCount = 0;
        this.todaysCountLoader = false;
      }
    );
  }

  sentWeeklyCount() {
    let args = {
      developerId: this.userData.id,
      applicationId: this.applicationContent["applicationId"],
      fromDate: moment().startOf("week").format("YYYY-MM-DD"),
      toDate: moment().endOf("week").format("YYYY-MM-DD"),
    };
    this.applicationService.totalSentMsgCount(args).subscribe(
      async (data) => {
        if (data && data.status == true) {
          this.totalCountDetails.weeklyCount = data.info.totalCount;
          this.weeklyCountLoader = false;
        } else {
          this.totalCountDetails.weeklyCount = 0;
          this.weeklyCountLoader = false;
        }
      },
      (err) => {
        this.totalCountDetails.weeklyCount = 0;
        this.weeklyCountLoader = false;
      }
    );
  }

  sentMonthlyCount() {
    let args = {
      developerId: this.userData.id,
      applicationId: this.applicationContent["applicationId"],
      fromDate: moment().startOf("month").format("YYYY-MM-DD"),
      toDate: moment().endOf("month").format("YYYY-MM-DD"),
    };
    this.applicationService.totalSentMsgCount(args).subscribe(
      async (data) => {
        if (data && data.status == true) {
          this.totalCountDetails.monthlyCount = data.info.totalCount;
          this.monthlyCountLoader = false;
        } else {
          this.totalCountDetails.monthlyCount = 0;
          this.monthlyCountLoader = false;
        }
      },
      (err) => {
        this.totalCountDetails.monthlyCount = 0;
        this.monthlyCountLoader = false;
      }
    );
  }

  sentYearlyCount() {
    let args = {
      developerId: this.userData.id,
      applicationId: this.applicationContent["applicationId"],
      fromDate: moment().startOf("year").format("YYYY-MM-DD"),
      toDate: moment().endOf("week").format("YYYY-MM-DD"),
    };
    this.applicationService.totalSentMsgCount(args).subscribe(
      async (data) => {
        if (data && data.status == true) {
          this.totalCountDetails.yearlyCount = data.info.totalCount;
          this.yearlyCountLoader = false;
        } else {
          this.totalCountDetails.yearlyCount = 0;
          this.yearlyCountLoader = false;
        }
      },
      (err) => {
        this.totalCountDetails.yearlyCount = 0;
        this.yearlyCountLoader = false;
      }
    );
  }

  receivedTodaysCount() {
    let args = {
      developerId: this.userData.id,
      applicationId: this.applicationContent["applicationId"],
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    };
    this.applicationService.totalReceivedMsgCount(args).subscribe(
      async (data) => {
        if (data && data.status == true) {
          this.totalCountDetails.todaysCount = data.info.totalCount;
          this.todaysCountLoader = false;
        } else {
          this.totalCountDetails.todaysCount = 0;
          this.todaysCountLoader = false;
        }
      },
      (err) => {
        this.totalCountDetails.todaysCount = 0;
        this.todaysCountLoader = false;
      }
    );
  }

  receivedWeeklyCount() {
    let args = {
      developerId: this.userData.id,
      applicationId: this.applicationContent["applicationId"],
      fromDate: moment().startOf("week").format("YYYY-MM-DD"),
      toDate: moment().endOf("week").format("YYYY-MM-DD"),
    };
    this.applicationService.totalReceivedMsgCount(args).subscribe(
      async (data) => {
        if (data && data.status == true) {
          this.totalCountDetails.weeklyCount = data.info.totalCount;
          this.weeklyCountLoader = false;
        } else {
          this.totalCountDetails.weeklyCount = 0;
          this.weeklyCountLoader = false;
        }
      },
      (err) => {
        this.totalCountDetails.weeklyCount = 0;
        this.weeklyCountLoader = false;
      }
    );
  }

  receivedMonthlyCount() {
    let args = {
      developerId: this.userData.id,
      applicationId: this.applicationContent["applicationId"],
      fromDate: moment().startOf("month").format("YYYY-MM-DD"),
      toDate: moment().endOf("month").format("YYYY-MM-DD"),
    };
    this.applicationService.totalReceivedMsgCount(args).subscribe(
      async (data) => {
        if (data && data.status == true) {
          this.totalCountDetails.monthlyCount = data.info.totalCount;
          this.monthlyCountLoader = false;
        } else {
          this.totalCountDetails.monthlyCount = 0;
          this.monthlyCountLoader = false;
        }
      },
      (err) => {
        this.totalCountDetails.monthlyCount = 0;
        this.monthlyCountLoader = false;
      }
    );
  }

  receivedYearlyCount() {
    let args = {
      developerId: this.userData.id,
      applicationId: this.applicationContent["applicationId"],
      fromDate: moment().startOf("year").format("YYYY-MM-DD"),
      toDate: moment().endOf("week").format("YYYY-MM-DD"),
    };
    this.applicationService.totalReceivedMsgCount(args).subscribe(
      async (data) => {
        if (data && data.status == true) {
          this.totalCountDetails.yearlyCount = data.info.totalCount;
          this.yearlyCountLoader = false;
        } else {
          this.totalCountDetails.yearlyCount = 0;
          this.yearlyCountLoader = false;
        }
      },
      (err) => {
        this.totalCountDetails.yearlyCount = 0;
        this.yearlyCountLoader = false;
      }
    );
  }

  selectDate(events) {
    if (events) {
      this.fromDate = moment(events[0]).format("MM-DD-YYYY");
      this.toDate = moment(events[1]).format("MM-DD-YYYY");
    }
  }

  reportDate(events) {
    if ((this.selectedReportDateRange = "choosedate")) {
      let to =
        events &&
        (events[1] !== null || events[1] !== undefined) &&
        events[1].getTime()
          ? events[1].getTime()
          : new Date(Date.parse(this.todate._d));
      let from =
        events &&
        (events[0] !== null || events[0] !== undefined) &&
        events[0].getTime()
          ? events[0].getTime()
          : new Date(Date.parse(this.fromDate._d));
      var Difference_In_Time = to - from;
      var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
      if (Difference_In_Days < 31) {
        if (events) {
          this.fromDate = moment(events[0]).format("YYYY-MM-DD");
          this.toDate = moment(events[1]).format("YYYY-MM-DD");
          this.reportDownloadBtn = true;
        }
      } else {
        this.reportDownloadBtn = false;
        this.toastr.error("Please select a date range within 31 days");
      }
    }
  }

  dateRangeCounts(id) {
    this.dateRangeDiv = false;
    let args = {
      developerId: this.userData.id,
      applicationId: this.applicationContent["applicationId"],
      fromDate: this.fromDate,
      toDate: this.toDate,
    };
    if (this.currentOpenConnectorId) {
      args["connectorId"] = this.currentOpenConnectorId;
    }
    if (id == "userDate") {
      this.audioDurationLoad=false;
      this.applicationService.getUserCount(args).subscribe((data) => {
        if (data && data.status == false) {
          if (data.info == "email_address_missing") {
            this.translate
              .get("Application.EmailMissing")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else if (data.info == "no_application") {
            this.translate
              .get("Application.NoApplication")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else if (data.info == "server_issue") {
            this.translate
              .get("Application.SomethingWrong")
              .subscribe((res: string) => {
                this.toastr.error(res);
              });
          } else {
            this.toastr.error("", data.info);
          }
        } else {
          this.dateRangeDiv = true;
          this.dateRangeCount = data.info.count;
        }
      });
    } else if (id == "msgSentDate") {
      this.audioDurationLoad=false;
      this.applicationService
        .totalSentMsgCount(args)
        .subscribe(async (data) => {
          if (data && data.status == false) {
            if (data.info == "email_address_missing") {
              this.translate
                .get("Application.EmailMissing")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else if (data.info == "no_application") {
              this.translate
                .get("Application.NoApplication")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else if (data.info == "server_issue") {
              this.translate
                .get("Application.SomethingWrong")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else {
              this.toastr.error("", data.info);
            }
          } else {
            this.dateRangeDiv = true;
            this.dateRangeCount = data.info.totalCount;
          }
        });
    } else if (id == "msgReceivedDate") {
      this.audioDurationLoad=false;
      this.applicationService
        .totalReceivedMsgCount(args)
        .subscribe(async (data) => {
          if (data && data.status == false) {
            if (data.info == "email_address_missing") {
              this.translate
                .get("Application.EmailMissing")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else if (data.info == "no_application") {
              this.translate
                .get("Application.NoApplication")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else if (data.info == "server_issue") {
              this.translate
                .get("Application.SomethingWrong")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else {
              this.toastr.error("", data.info);
            }
          } else {
            this.dateRangeDiv = true;
            this.dateRangeCount = data.info.totalCount;
          }
        });
    } else if (id == "connectorMsgSentDate") {
      this.audioDurationLoad=false;
      this.applicationService
        .getConnectorMessageSentCount(args)
        .subscribe((data) => {
          if (data && data.status == false) {
            this.toastr.error("", data.info);
          } else {
            this.dateRangeDiv = true;
            this.dateRangeCount = data.info.count;
          }
        });
    } else if (id == "receivedNotificationDate") {
      this.audioDurationLoad=false;
      let args1 = {
        developerId: this.userData.id,
        applicationId: this.applicationContent["applicationId"],
        connectorId: this.whatsAppConnFilter[0].id,
        fromDate: this.fromDate,
        toDate: this.toDate,
      };
      this.applicationService
        .receivedNotificationMessage(args1)
        .subscribe((data) => {
          if (data && data.status == false) {
            this.toastr.error("", data.info);
          } else {
            this.dateRangeDiv = true;
            this.dateRangeCount = data.info.count;
          }
        });
    } else if (id == "tempalteCoDate") {
      this.templateLoader = true;
      this.audioDurationLoad=false;
      let args1 = {
        developerId: this.userData.id,
        applicationId: this.applicationContent["applicationId"],
        connectorId: this.whatsAppConnFilter[0].id,
        fromDate: this.fromDate,
        toDate: this.toDate,
      };
      this.applicationService.totalTemplatecount(args1).subscribe(
        (res) => {
          if (res && res.status == true) {
            this.templateConnectors = [];
            this.page = 1;
            console.log("res template", res)
            this.totalTempalteLoader = false;
            this.templateLoader = false;
            this.totalTempalteLoader = false;
          this.templateLoader = false;
          this.templateDetails = res.info;
          for (const data of Object.entries(res.info)) {
            let obj = {}
            var temp = data[1]["template"]
            if(temp && Object.keys(temp).length) {
              obj["title"] = this.channelNameChange(data[0])
           let tempObj = Object.entries(temp);
             obj["template"] = tempObj;
              this.templateConnectors.push(obj)
            }
          }
          this.templateConnectorsBackup = this.templateConnectors
          this.paginationCount = this.templateConnectors.length;
          this.templateConnectors = this.templateConnectors.slice(
         (this.page-1) * 1,
         (this.page-1) * 1 + 1
       );
            this.dateRangeDiv = true;
            this.dateRangeCount = res.info.total;

          } else {
            this.totalTemplate = 0;
            this.totalTempalteLoader = false;
            this.templateLoader = false;
          }
        },
        (err) => {
          this.totalTemplate = 0;
          this.totalTempalteLoader = false;
          this.templateLoader = false;
        }
      );
    } else if (id == "audioDuration") {
      this.audioDurationLoad= true;
      let args = {
        applicationId: this.applicationContent["applicationId"],
        fromDate: this.fromDate,
        toDate: this.toDate,
      };
      this.applicationService.audiototextCount(args).subscribe(
        (res) => {
             this.dateRangeDiv = true;
            this.dateRangeCount = (res && res.status == true) ? this.secondsToHms(res.info.totalDuration): 0;
        },(err) => {
          console.log(err)
         }
      )}else {
        this.audioDurationLoad=true;
      this.applicationService
        .getConnectorHsmSentCount(args)
        .subscribe((data) => {
          if (data && data.status == false) {
            if (data.info == "email_address_missing") {
              this.translate
                .get("Application.EmailMissing")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else if (data.info == "no_application") {
              this.translate
                .get("Application.NoApplication")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else if (data.info == "server_issue") {
              this.translate
                .get("Application.SomethingWrong")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else if (data.info == "no_connector") {
              this.translate
                .get("Common.NoConnector")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else if (data.info == "no_connector_in_app") {
              this.translate
                .get("Application.NoConnector")
                .subscribe((res: string) => {
                  this.toastr.error(res);
                });
            } else {
              this.toastr.error("", data.info);
            }
          } else {
            this.dateRangeDiv = true;
            this.dateRangeCount = data.info.count;
          }
        });
    }
  }

  closeModel() {
    location.replace("application");
    this.registerUrl = "";
    this.botDetailsId = "";
    this.selectedConnector = "";
    this.selectedIndex = 0;
    this.nextButtonDisable = true;
    this.selectedIndex = 0;
    this.appSecretRequiredError = "";
    this.appKeyRequiredError = "";
    this.registerUrlRequiredError = "";
    this.botDetailsIdRequiredError = "";
    this.appKey = "";
    this.appURLHandle = "";
    this.appSecret = "";
    this.displayNext = "block";
    this.display = "none";
    this.disableBotIdAndUrlInput = false;
  }

  closeFBModel() {
    this.registerUrl = "";
    this.botDetailsId = "";
    this.selectedConnector = "";
    this.selectedIndex = 0;
    this.nextButtonDisable = true;
    this.selectedIndex = 0;
    this.appSecretRequiredError = "";
    this.appKeyRequiredError = "";
    this.registerUrlRequiredError = "";
    this.botDetailsIdRequiredError = "";
    this.appKey = "";
    this.appURLHandle = "";
    this.appSecret = "";
    this.displayNext = "block";
    this.display = "none";
    this.disableBotIdAndUrlInput = false;
  }

  setTranslationLanguage(e) {
    if (e.target.value !== "0") {
      this.enabilecheckbox = false;
    } else {
      this.enabilecheckbox = true;
      this.applicationContent.translate = false;
      this.enableTranslation(false);
    }
    let args = {
      developerId: this.userData.id,
      applicationId: this.applicationContent["applicationId"],
      language: e.target.value,
    };

    this.applicationService.setTranslationLanguage(args).subscribe((data) => {
      if (data && data.status == false) {
        this.toastr.error("", data.info);
      } else {
        //Do Nothing
      }
    });
  }

  callbackpersist(e) {
    this.callbackper = e.target.checked;
    if (this.callbackper) {
      this.callbackPersistCountChange(1);
    } else {
      this.callbackPersistCountChange(0);
    }
    let args = {
      developerId: this.userData.id,
      applicationId: this.applicationContent["applicationId"],
      enable: e && e.target && e.target.checked ? e.target.checked : false,
    };

    this.applicationService.callbackpersist(args).subscribe((data) => {
      if (data && data.status == false) {
        this.toastr.error("", data.info);
      } else {
        //Do Nothin
      }
    });

    this.applicationService.deleteRetryMessages(args).subscribe((data1) => {
      if (data1 && data1.status == false) {
        this.toastr.error("", data1.info);
      } else {
        //Do Nothing
      }
    });
  }

  enableTranslation(e) {
    let args = {
      developerId: this.userData.id,
      applicationId: this.applicationContent["applicationId"],
      enable: e && e.target && e.target.checked ? e.target.checked : false,
    };

    this.applicationService.enableTranslation(args).subscribe((data) => {
      if (data && data.status == false) {
        this.toastr.error("", data.info);
      } else {
        //Do Nothing
      }
    });
  }

  callbackPersistCountChange($event) {
    let args = {
      developerId: this.userData.id,
      applicationId: this.applicationContent["applicationId"],
      count: $event,
    };
    this.applicationService.callBackPersistCount(args).subscribe((data) => {
      if (data && data.status == false) {
        this.toastr.error("", data.info);
      } else {
        this.callBackPersistCount = $event;
      }
    });
  }

  totalSentMsgCount(id) {
    this.totalSentMessageLoader = true;
    let args = { developerId: this.userData.id, applicationId: id };

    this.applicationService.totalSentMsgCount(args).subscribe(
      (res) => {
        if (res && res.status == true) {
          this.totalSentMessages = res.info.totalCount;
          this.totalSentMessageLoader = false;
        } else {
          this.totalSentMessageLoader = false;
        }
      },
      (err) => {
        this.totalSentMessageLoader = false;
      }
    );
  }

  activeUsersMonth(id) {
    this.activeMonthlyUsersLoader = true;
    var datestart1 = moment(this.todaysDate)
      .subtract(0, "year")
      .startOf("year")
      .format("YYYY-MM-DD");
    var dateend1 = moment(this.todaysDate)
      .subtract(1, "year")
      .startOf("year")
      .format("YYYY-MM-DD");
    var check1 = moment(datestart1, "YYYY/MM/DD");
    var check2 = moment(dateend1, "YYYY/MM/DD");
    this.year1 = check1.format("YYYY");
    this.year2 = check2.format("YYYY");
    this.yearSelect = [
      { id: 1, name: this.year1 },
      { id: 2, name: this.year2 },
    ];
    this.check = moment(this.todaysDate, "YYYY/MM/DD");
    this.month = this.check.format("M");
    this.year = this.check.format("YYYY");
    if (this.month == "1") {
      this.monthName = "January";
    } else if (this.month == "2") {
      this.monthName = "February";
    } else if (this.month == "3") {
      this.monthName = "March";
    } else if (this.month == "4") {
      this.monthName = "April";
    } else if (this.month == "5") {
      this.monthName = "May";
    } else if (this.month == "6") {
      this.monthName = "June";
    } else if (this.month == "7") {
      this.monthName = "July";
    } else if (this.month == "8") {
      this.monthName = "August";
    } else if (this.month == "9") {
      this.monthName = "September";
    } else if (this.month == "10") {
      this.monthName = "October";
    } else if (this.month == "11") {
      this.monthName = "November";
    } else if (this.month == "12") {
      this.monthName = "December";
    }

    let argsmonthlyactiveuser = {
      developerId: this.userData.id,
      applicationId: id,
      year: this.year,
      month: this.monthName,
    };

    this.applicationService
      .getMonthlyActiveUsers(argsmonthlyactiveuser)
      .subscribe(
        (data) => {
          if (data) {
            this.activemonthlyusersboolean = true;
            this.activeMonthlyUsers = data.info.count;
            this.activeMonthlyUsersLoader = false;
          } else {
            this.activemonthlyusersboolean = false;
            this.activeMonthlyUsersLoader = false;
          }
        },
        (err) => {
          this.activemonthlyusersboolean = false;
          this.activeMonthlyUsersLoader = false;
        }
      );
  }

  totalTemplatecount(id) {
  this.totalTemplatePage = [];
  this.templateLoader = true;
    this.totalTempalteLoader = false;
    let args = {
      developerId: this.userData.id,
      applicationId: id,
      connectorId: this.whatsAppConnFilter[0].id,
    };
       this.applicationService.totalTemplatecount(args).subscribe(
      (res) => {
        if (res && res.status == true) {
          this.templateConnectors = [];
          this.totalTempalteLoader = false;
          this.templateLoader = false;
          this.templateDetails = res.info;
          for (const data of Object.entries(res.info)) {
            let obj = {}
            var temp = data[1]["template"]
            if(temp && Object.keys(temp).length) {
              obj["title"] = this.channelNameChange(data[0])
           let tempObj = Object.entries(temp);
             obj["template"] = tempObj;
              this.templateConnectors.push(obj)
            }
          }
          this.templateConnectorsBackup = this.templateConnectors
          this.paginationCount = this.templateConnectors.length;
          this.templateConnectors = this.templateConnectors.slice(
         (this.page-1) * 1,
         (this.page-1) * 1 + 1
       );
          } else {
          this.totalTemplate = 0;
          this.totalTempalteLoader = false;
          this.templateLoader = false;
        }
      },
      (err) => {
        this.totalTemplate = 0;
        this.totalTempalteLoader = false;
        this.templateLoader = false;
      }
    );
  }
  channelNameChange(item) {
    let value;
    if (item === 'whatsappCloud') {
      value = 'WhatsApp Cloud';
    } else if (item === 'whatsappOfficial') {
      value = 'WhatsApp';
    } else if (item === 'whatsappSandbox') {
      value = 'WhatsApp Sandbox';
    } else if (item === 'whatsappTrial') {
      value = 'WhatsApp Trial';
    } else {
      value = item;
    }
    return value;
   }
  totalSentMsgAfterRenewedCount(id, renewalDate) {
    this.totalSentMessageAfterRenewedLoader = true;
    let args = {
      developerId: this.userData.id,
      applicationId: id,
      fromDate: moment(renewalDate).format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    };

    this.applicationService.totalSentMsgCount(args).subscribe(
      (res) => {
        if (res && res.status == true) {
          this.totalSentMessagesAfterRenewed = res.info.totalCount;
          this.totalSentMessageAfterRenewedLoader = false;
        } else {
          this.totalSentMessageAfterRenewedLoader = false;
        }
      },
      (err) => {
        this.totalSentMessageAfterRenewedLoader = false;
      }
    );
  }

  totalReceivedMsgCount(id) {
    this.totalReceivedMessageLoader = true;
    let args = { developerId: this.userData.id, applicationId: id };

    this.applicationService.totalReceivedMsgCount(args).subscribe(
      (res) => {
        if (res && res.status == true) {
          this.totalReceivedMessages = res.info.totalCount;
          this.totalReceivedMessageLoader = false;
        } else {
          this.totalReceivedMessageLoader = false;
        }
      },
      (err) => {
        this.totalReceivedMessageLoader = false;
      }
    );
  }

  totalReceivedMsgAfterRenewedCount(id, renewalDate) {
    this.totalReceivedMessageAfterRenewedLoader = true;
    let args = {
      developerId: this.userData.id,
      applicationId: id,
      fromDate: moment(renewalDate).format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    };

    this.applicationService.totalReceivedMsgCount(args).subscribe(
      (res) => {
        if (res && res.status == true) {
          this.totalReceivedMessagesAfterRenewed = res.info.totalCount;
          this.totalReceivedMessageAfterRenewedLoader = false;
        } else {
          this.totalReceivedMessageAfterRenewedLoader = false;
        }
      },
      (err) => {
        this.totalReceivedMessageAfterRenewedLoader = false;
      }
    );
  }
  receivedNotificationMessageCount(id) {
    this.receivedNotificationMessageLoader = true;
    let args = {
      developerId: this.userData.id,
      applicationId: id,
      connectorId: this.whatsAppConnFilter[0].id,
    };

    this.applicationService.receivedNotificationMessage(args).subscribe(
      (res) => {
        if (res && res.status == true) {
          this.receivedNotificationMsgCount = res.info.count;
          this.receivedNotificationMessageLoader = false;
        } else {
          this.receivedNotificationMessageLoader = false;
        }
      },
      (err) => {
        this.receivedNotificationMessageLoader = false;
      }
    );
  }
  receivedTodaysNotificationCount() {
    let args = {
      developerId: this.userData.id,
      applicationId: this.applicationContent["applicationId"],
      connectorId: this.whatsAppConnFilter[0].id,
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    };
    this.applicationService.receivedNotificationMessage(args).subscribe(
      (data) => {
        if (data && data.status == true) {
          this.totalCountDetails.todaysCount = data.info.count;
          this.todaysCountLoader = false;
        } else {
          this.totalCountDetails.todaysCount = 0;
          this.todaysCountLoader = false;
        }
      },
      (err) => {
        this.totalCountDetails.todaysCount = 0;
        this.todaysCountLoader = false;
      }
    );
  }

  receivedWeeklyNotificationCount() {
    let args = {
      developerId: this.userData.id,
      applicationId: this.applicationContent["applicationId"],
      connectorId: this.whatsAppConnFilter[0].id,
      fromDate: moment().startOf("week").format("YYYY-MM-DD"),
      toDate: moment().endOf("week").format("YYYY-MM-DD"),
    };
    this.applicationService.receivedNotificationMessage(args).subscribe(
      (data) => {
        if (data && data.status == true) {
          this.totalCountDetails.weeklyCount = data.info.count;
          this.weeklyCountLoader = false;
        } else {
          this.totalCountDetails.weeklyCount = 0;
          this.weeklyCountLoader = false;
        }
      },
      (err) => {
        this.totalCountDetails.weeklyCount = 0;
        this.weeklyCountLoader = false;
      }
    );
  }

  receivedMonthlyNotificationCount() {
    let args = {
      developerId: this.userData.id,
      applicationId: this.applicationContent["applicationId"],
      connectorId: this.whatsAppConnFilter[0].id,
      fromDate: moment().startOf("month").format("YYYY-MM-DD"),
      toDate: moment().endOf("month").format("YYYY-MM-DD"),
    };
    this.applicationService.receivedNotificationMessage(args).subscribe(
      (data) => {
        if (data && data.status == true) {
          this.totalCountDetails.monthlyCount = data.info.count;
          this.monthlyCountLoader = false;
        } else {
          this.totalCountDetails.monthlyCount = 0;
          this.monthlyCountLoader = false;
        }
      },
      (err) => {
        this.totalCountDetails.monthlyCount = 0;
        this.monthlyCountLoader = false;
      }
    );
  }

  receivedYearlyNotificationCount() {
    let args = {
      developerId: this.userData.id,
      applicationId: this.applicationContent["applicationId"],
      connectorId: this.whatsAppConnFilter[0].id,
      fromDate: moment().startOf("year").format("YYYY-MM-DD"),
      toDate: moment().endOf("week").format("YYYY-MM-DD"),
    };
    this.applicationService.receivedNotificationMessage(args).subscribe(
      (data) => {
        if (data && data.status == true) {
          this.totalCountDetails.yearlyCount = data.info.count;
          this.yearlyCountLoader = false;
        } else {
          this.totalCountDetails.yearlyCount = 0;
          this.yearlyCountLoader = false;
        }
      },
      (err) => {
        this.totalCountDetails.yearlyCount = 0;
        this.yearlyCountLoader = false;
      }
    );
  }

  pageChanged2(page) {
    this.page = page;
    this.templateConnectors = this.templateConnectorsBackup.slice(
      (this.page - 1) * 1,
      (this.page - 1) * 1 + 1
    );
  }
  dataRangeCancel() {
    this.toDate = moment();
    this.fromDate = moment().subtract(30, "days");
    this.bsRangeValue = [
      new Date(Date.parse(this.fromDate._d)),
      new Date(Date.parse(this.toDate._d)),
    ];
  }

  switchDateRange() {
    if (this.selectedDateRange === "last30") {
      this.toDate = moment(new Date()).format("YYYY-MM-DD");
      this.fromDate = moment(new Date())
        .subtract(30, "days")
        .format("YYYY-MM-DD");
    }
    if (this.selectedDateRange === "choosedate") {
      this.toDate = moment(new Date()).format("YYYY-MM-DD");
      this.fromDate = moment(new Date())
        .subtract(30, "days")
        .format("YYYY-MM-DD");
    }
  }

  switchReportDateRange() {
    this.reportDownloadBtn = false;
    if (this.selectedReportDateRange === "today") {
      this.toDate = moment(new Date()).format("YYYY-MM-DD");
      this.fromDate = moment(new Date()).format("YYYY-MM-DD");
      this.reportDownloadBtn = true;
    }
    if (this.selectedReportDateRange === "last7") {
      this.toDate = moment(new Date()).format("YYYY-MM-DD");
      this.fromDate = moment(new Date())
        .subtract(7, "days")
        .format("YYYY-MM-DD");
      this.reportDownloadBtn = true;
    }
    if (this.selectedReportDateRange === "last30") {
      this.toDate = moment(new Date()).format("YYYY-MM-DD");
      this.fromDate = moment(new Date())
        .subtract(30, "days")
        .format("YYYY-MM-DD");
      this.reportDownloadBtn = true;
    }
    if (this.selectedReportDateRange === "choosedate") {
      this.toDate = moment(new Date()).format("YYYY-MM-DD");
      this.fromDate = moment(new Date())
        .subtract(30, "days")
        .format("YYYY-MM-DD");
      this.bsRangeValue = [
        new Date(Date.parse(this.fromDate)),
        new Date(Date.parse(this.toDate)),
      ];
    }
  }

  closeReportModel() {
    this.selectedReportDateRange = "today";
  }

  monthlyActiveUsersReportDownload() {
    this.reportloadershow = true;
    this.activeUserReport = true;
    const fileName =
      "Monthly_active_users_report_" +
      moment().format("Y-M-D_H-mm-ss") +
      ".xlsx";
    if (this.dashboardChartDetails.length > 0) {
      let data = this.dashboardChartDetails;
      const opts = {
        headers: true,
        column: { style: { Font: { Bold: "1" } } },
        rows: { 1: { style: { Font: { Color: "#FF0077" } } } },
        cells: {
          1: {
            1: {
              style: { Font: { Color: "#00FFFF" } },
            },
          },
        },
      };

      data.forEach((element) => {
        element.appName = this.applicationContent.name;
      });

      alasql(
        'SELECT [appName] as [Application Name], [year] as [Year], [month] as [Month], [count] as [Count] INTO XLSX("' +
          fileName +
          '",?) FROM ?',
        [opts, this.dashboardChartDetails]
      );
      this.reportloadershow = false;
      this.activeUserReport = false;
    } else {
      this.toastr.error("No data found for selected range");
      this.activeUserReport = false;
      this.reportloadershow = false;
    }
  }

  updateStatus() {
    this.updateCustomerIdStatus = true;
    this.addCustomerIdStatus = false;
  }
  cancelUpdate() {
    this.customerId = this.applicationContent.customerId;
    this.updateCustomerIdStatus = false;
    this.addCustomerIdStatus = false;
  }
  customerIdUpdate() {
    if (this.customerId != "") {
      const args = {
        developerId: this.userData.id,
        applicationId: this.applicationContent.applicationId,
        customerId: this.customerId,
      };

      this.applicationService.updateCustomerId(args).subscribe((data) => {
        if (data.status) {
          //this.loaderTrue = false;
          this.toastr.success(" Customer id updated successfully.");
          this.applicationContent.customerId = this.customerId;
          this.cancelUpdate();
        }
      });
    } else {
      this.toastr.error("Please enter customer id");
    }
  }

  addStatus() {
    this.addCustomerId = ""
    this.addCustomerIdStatus = true;
    this.updateCustomerIdStatus = false;
  }
  cancelAdd() {
    this.addCustomerIdStatus = false;
    this.updateCustomerIdStatus = false;
  }
  customerIdAdd() {
    //this.loaderTrue = true;
    //console.log('addCustomerId:',this.addCustomerId);
    if (this.addCustomerId != "") {
      const args = {
        developerId: this.userData.id,
        applicationId: this.applicationContent.applicationId,
        customerId: this.addCustomerId,
      };

      this.applicationService.updateCustomerId(args).subscribe((data) => {
        if (data.status) {
          //this.loaderTrue = false;
          this.toastr.success(" Customer id added successfully.");
          this.applicationContent.customerId = this.addCustomerId;
          this.customerId = this.applicationContent.customerId;
          this.cancelAdd();
        }
      });
    } else {
      this.toastr.error("Please enter customer id");
    }
  }

  deleteCustomerId() {
    const args = {
      developerId: this.userData.id,
      applicationId: this.applicationContent.applicationId,
      customerId: "",
    };
    this.applicationService.updateCustomerId(args).subscribe((data) => {
      if (data.status) {
        this.toastr.success(" Customer id deleted successfully.");
        this.applicationContent.customerId = "";
        this.addCustomerId = "";
        this.customerId = "";
        this.cancelAdd();
        this.cancelUpdate();
      }
    });
  }

  /****************************************************************************** */
  updateNameStatus() {
    this.updateCustomerNameStatus = true;
    this.addCustomerNameStatus = false;
  }
  cancelNameUpdate() {
    this.customerName = this.applicationContent.customerName;
    this.updateCustomerNameStatus = false;
    this.addCustomerNameStatus = false;
  }
  customerNameUpdate() {
    if (this.customerName != "") {
      // var regex = /^[a-zA-Z]*$/;
      // if (regex.test(this.customerName)) {
        const args = {
          developerId: this.userData.id,
          applicationId: this.applicationContent.applicationId,
          customerName: this.customerName,
        };

        this.applicationService.updateCustomerName(args).subscribe((data) => {
          if (data.status) {
            //this.loaderTrue = false;
            this.toastr.success(" Customer name updated successfully.");
            this.applicationContent.customerName = this.customerName;
            this.cancelNameUpdate();
          }
        });
      // } else {
      //   this.toastr.error("Please enter a valid customer name");
      // }
    } else {
      this.toastr.error("Please enter customer name");
    }
  }

  addNameStatus() {
    this.addCustomerName = "";
    this.addCustomerNameStatus = true;
    this.updateCustomerNameStatus = false;
  }
  cancelNameAdd() {
    this.addCustomerNameStatus = false;
    this.updateCustomerNameStatus = false;
  }
  customerNameAdd() {
    //this.loaderTrue = true;
    if (this.addCustomerName != "") {
      const args = {
        developerId: this.userData.id,
        applicationId: this.applicationContent.applicationId,
        customerName: this.addCustomerName,
      };

      this.applicationService.updateCustomerName(args).subscribe((data) => {
        if (data.status) {
          //this.loaderTrue = false;
          this.toastr.success(" Customer name added successfully.");
          this.applicationContent.customerName = this.addCustomerName;
          this.customerName = this.applicationContent.customerName;
          this.cancelNameAdd();
        }
      });
    } else {
      this.toastr.error("Please enter customer name");
    }
  }

  deleteCustomerName() {
    const args = {
      developerId: this.userData.id,
      applicationId: this.applicationContent.applicationId,
      customerName: "",
    };
    this.applicationService.updateCustomerName(args).subscribe((data) => {
      if (data.status) {
        this.toastr.success(" Customer name deleted successfully.");
        this.applicationContent.customerName = "";
        this.addCustomerName = "";
        this.customerName = "";
        this.cancelNameAdd();
        this.cancelNameUpdate();
      }
    });
  }

  /****************************************************************************** */

  connectorType(event) {
    this.noRecordsFound = false;
    this.search = "";
    this.addConnectorDetails = this.addConnectorDetails2;
    var data = [];
    this.addConnectorDetails.forEach((element) => {
      if (element.type == event.target.defaultValue) {
        data.push(element);
      }
    });
    if (data && data.length <= 0) {
      this.noRecordsFound = true;
    }
    this.addConnectorDetails3 = data;
    this.addConnectorDetails = data;
  }

  onKeyup(search) {
    this.noRecordsFound = false;
    var data = [];
    if (search != "") {
      var res;
      var x;
      this.addConnectorDetails3?.forEach((element) => {
        res = this.isSubstring(search.toLowerCase(), element.name.toLowerCase());
        if (res == -1) {
          //do nothing
        } else {
          data.push(element);
        }
      });
      //console.log('data',data);
      if (data && data.length == 0) {
        this.noRecordsFound = true;
      }
      this.addConnectorDetails = data;
    } else {
      this.addConnectorDetails = this.addConnectorDetails3;
    }
  }

  clearClick() {}
  isSubstring(s1, s2) {
    var M = s1.length;
    var N = s2.length;

    /* A loop to slide pat[] one by one */
    for (var i = 0; i <= N - M; i++) {
      var j;

      /* For current index i, check for
 pattern match */
      for (j = 0; j < M; j++) if (s2[i + j] != s1[j]) break;

      if (j == M) return i;
    }

    return -1;
  }
   audioTodaysCount(){
     this.audioDurationLoad = true;
   this.todaysCountLoader=true;
    let args = {
      applicationId: this.applicationContent["applicationId"],
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    };
    this.applicationService.audiototextCount(args).subscribe(
      (data) => {
        this.audioTodayCount= (data && data.status == true) ? this.secondsToHms(data.info.totalDuration) : 0
        this.todaysCountLoader = false;
      },
      (err) => {
        this.totalCountDetails.todaysCount = 0;
        this.todaysCountLoader = false;
      }
    );
  }
   audioReceivedWeeklyCount(){
    this.audioDurationLoad= true;
    this.weeklyCountLoader = true;
    let args = {
      applicationId: this.applicationContent["applicationId"],
      fromDate: moment().startOf("week").format("YYYY-MM-DD"),
      toDate: moment().endOf("week").format("YYYY-MM-DD"),
    };
    this.applicationService.audiototextCount(args).subscribe(
      (data) => {
        this.audioWeeklyCount= (data && data.status == true) ? this.secondsToHms(data.info.totalDuration) : 0
          this.weeklyCountLoader = false;
      },
      (err) => {
        this.totalCountDetails.weeklyCount = 0;
        this.weeklyCountLoader = false;
      }
    );
   }
   audioReceivedMonthlyCount(){
    this.audioDurationLoad= true;
    this.monthlyCountLoader = true;
    let args = {
      applicationId: this.applicationContent["applicationId"],
      fromDate: moment().startOf("month").format("YYYY-MM-DD"),
      toDate: moment().endOf("month").format("YYYY-MM-DD"),
    };
    this.applicationService.audiototextCount(args).subscribe(
      (data) => {
        this.audioMonthlyCount= (data && data.status == true) ? this.secondsToHms(data.info.totalDuration) : 0
          this.monthlyCountLoader = false;
      },
      (err) => {
        this.totalCountDetails.monthlyCount = 0;
        this.monthlyCountLoader = false;
      }
    );
   }
   audioReceivedYearlyCount(){
    this.audioDurationLoad= true;
    this.yearlyCountLoader = true;
    let args = {
      applicationId: this.applicationContent["applicationId"],
      fromDate: moment().startOf("year").format("YYYY-MM-DD"),
      toDate: moment().endOf("week").format("YYYY-MM-DD"),
    };
    this.applicationService.audiototextCount(args).subscribe(
      (data) => {
        this.audioYearlyCount= (data && data.status == true) ? this.secondsToHms(data.info.totalDuration) : 0
          this.yearlyCountLoader = false;
      },
      (err) => {
        this.totalCountDetails.yearlyCount = 0;
        this.yearlyCountLoader = false;
      }
    );
   }
   audioReceivedCount(applicationId){
    this.audioDurationLoad=true;
    this.audioReceivedTotalDurationLoader = true;
    let args = {
      applicationId: applicationId,
    };
    this.applicationService.audiototextCount(args).subscribe(
      (data) => {
          this.audioReceivedTotalDuration = (data && data.status == true) ? this.secondsToHms(data.info.totalDuration) : 0
          this.audioReceivedTotalDurationLoader = false;
      },
      (err) => {
        this.audioReceivedTotalDurationLoader = false;
      }
    );
   }
   secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);
    var hDisplay = h > 0 ? h + (h == 1 ? "h " : "h ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? "m " : "m ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? "s" : "s") : "";
    return hDisplay + mDisplay + sDisplay ? hDisplay + mDisplay + sDisplay: 0;
  }
   processFileEdit(event) {
   this.uploadloader = true;
   this.loadershow = true;
   const Editfiles = event.target.files; // FileList object
   const file = Editfiles[0];
   const file2 = Editfiles[0].name;
   const filename = file2.split('.').slice(0, -1).join('.');
   const pattern = /image-*/;
   const reader = new FileReader();
    const sizeinMb = (file.size / (1024 * 1024)).toFixed(2);
    if (!file.type.match(pattern)) {
         this.toastr.error('', 'invalid format');
      if(this.fileInputEdit && this.fileInputEdit.nativeElement){
        this.fileInputEdit.nativeElement.value = '';
        }
      this.uploadloader = false;
        return;
     }
    reader.readAsBinaryString(file);
    reader.onload = (onloadEvent: any) => {
    const Data = onloadEvent.target.result;
    const contentData = btoa(Data);
    let args = {
        developerId: this.userData.id,
        accessKey: this.openConnector.applicationOriginalKey,
        secret: this.openConnector.applicationSecret,
        connectorId: this.openConnector.id,
        applicationId: this.applicationContent["applicationId"],
        optionalParams: this.openConnector.optionalOriginalParams,
        botDetails: this.openConnector.botDetails,
        urlHandle: this.openConnector.urlHandle,
        connectorScheme: this.openConnector.scheme,
        channelQrCode: contentData,
        channelQrCodeContentType: file.type
       };
    this.applicationService.QRcodeUpload(args).subscribe(response => {
           if(response.status === true){
        this.uploadloader = false;
          if (response.info.channelQrCode) {
            this.translate
          .get("QR code updated successfully")
          .subscribe((res: string) => {
            this.toastr.success(res);
          });
            let applicationArgs = {
              developerId: this.userData.id,
            };
            this.loadershow = false;
            this.getApplicationList(applicationArgs);
            } else {
            this.toastr.info('', response.info);
              }
            }
            }, err => {
            console.log('ERROR2', err);
            this.uploadloader = false;
            this.fileInputEdit.nativeElement.value = '';
            });
            };
        }
 imageCrossClick() {
  this.uploadloader = true;
  this.channelQrCode = '';
  if(this.fileInputEdit && this.fileInputEdit.nativeElement && this.fileInputEdit.nativeElement.value){
  this.fileInputEdit.nativeElement.value = '';
  }
  let args = {
    developerId: this.userData.id,
    accessKey: this.openConnector.applicationOriginalKey,
    secret: this.openConnector.applicationSecret,
    connectorId: this.openConnector.id,
    applicationId: this.applicationContent["applicationId"],
    optionalParams: this.openConnector.optionalOriginalParams,
    botDetails: this.openConnector.botDetails,
    urlHandle: this.openConnector.urlHandle,
    connectorScheme: this.openConnector.scheme,
    channelQrCode: '',
    channelQrCodeContentType: ''
   };
    this.applicationService.QRcodeUpload(args).subscribe(response => {
      if (response.status === true) {
        this.uploadloader = false;
        this.translate
          .get("QR code removed successfully")
          .subscribe((res: string) => {
            this.toastr.success(res);
          });
        let applicationArgs = {
          developerId: this.userData.id,
        };
        // this.loadershow = false;
        this.getApplicationList(applicationArgs);
      }
    })
  }
  radioValueChange(value) {
    this.connectorValue = value;
    if (value == 'embeddedSignUp') {
      this.chooseEmbedded = true;
    } else { this.chooseEmbedded = false; }
  }
  twitterlogin() {
    let applicationId = this.applicationContent.applicationId;
    this.applicationService.twitterFetchAuth(applicationId).subscribe(response => {
      console.log("resp", response);
      if (response && response.status) {
        if (response.info) {
          var oauth_token = response.info.oauth_token
        }
        window.location.href = `https://api.twitter.com/oauth/authenticate?oauth_token=${oauth_token}`
      }
    })
  }
  checkLabelretiveName(connection) {
    const scheme = ['audiototextconverter', 'huggingchat', 'rag', 'languagetranslator', 'gemini', 'openai'];
    return scheme.includes(connection.scheme)
  }
  tiktoklogin() {
    let clientId = this.tiktokClientId;
    let redirectUrl = encodeURIComponent(this.tiktokRedirectURL);
    let state = this.applicationContent.applicationId;
    window.location.href = `https://www.tiktok.com/v2/auth/authorize?client_key=${clientId}&redirect_uri=${redirectUrl}&scope=user.info.basic%2Cuser.info.username%2Cuser.info.stats%2Cuser.info.profile%2Cuser.account.type%2Cuser.insights%2Cvideo.list%2Cvideo.insights%2Ccomment.list%2Ccomment.list.manage%2Cvideo.publish%2Cvideo.upload%2Cbiz.spark.auth%2Cmessage.list.read%2Cmessage.list.send%2Cmessage.list.manage&response_type=code&state=${state}`;
  }
}
